import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
  ...zhLocale,
  // 提示
  message: {
    welcome: '欢迎',
    tip: '提示',
    loginFailed: '帐号或密码错误',
    signOut: '是否确认退出?',
    removeBrandTip: '你确定要移除这个品牌吗?',
    removeProductTip: '你确定要移除这个产品吗?',
    removeFormulaTip: '你确定要移除这个配方吗?',
    removeIngredientTip: '你确定要移除这个成分吗?',
    enableTip: '你确定要启用吗?',
    disableTip: '你确定要停用吗?',
    contactName: '联系人姓名不能为空!',
    email: '电子邮件名称不能为空!',
    validEmail: '请输入有效的电子邮件地址!',
    company: '公司名称不能为空!',
    address: '地址不能为空!',
    submitOrder: '你确定要提交订单吗?',
    addSuccess: '添加成功',
    saveSuccess: '保存成功',
    sendSuccess: '发送成功',
    success: '成功',
    fail: '失败',
    emptyFile: '未选中任何文件',
    deleteSuccess: '删除成功',
    comparisonExists: '比较已存在。',
    score: '请选择评分',
    comments: '请输入评论',
    successFeedback: '意见已成功反馈',
    failureFeedback: '抱歉，意见反馈失败',
    successSupport: '技术支持已成功反馈',
    failureSupport: '抱歉，技术支持反馈失败',
    passwordEmpty: '密码不能为空',
    newPasswordEmpty: '新密码不能为空',
    ConfirmPasswordEmpty: '确认密码不能为空',
    samePassword: '不能与旧密码相同',
    passwordDifferent: '新密码与确认密码不相同',
    successPassword: '密码修改成功',
    passwordEror: '旧密码错误',
    denyNeeded: '请填写驳回原因',
    notAvailable: '权重已占用',
    required: '必填',
    fileMaxSize: '不得超过', // eg. 文件不得超过20M
    emptyMessage: '回复不能为空',
    sureSubmit: '确认提交编辑的内容？',
    noPermission: '无此模块权限，如需查看请联系客户服务申请权限',
    selectOne: '至少选一项',
    codeEmpty: '验证码不能为空',
    emailEmpty: '邮箱不能为空',
    frequentlyTips: '访问频繁，请您先完成验证',
    updatePasswordTip: {
      title: '修改密码提醒',
      content: '您至少需要每5个月修改一次密码，请您尽快修改密码，以免账户被锁定后影响您正常使用系统。<p>上次修改密码时间： <span style="color: #FF6600">{current}</span></p>',
      noPassRecord: '无修改密码记录'
    },
    accountLockTip: {
      title: '账户锁定提醒',
      content: '由于您5个月内未修改登录密码，您的账号已被锁定。请您修改密码后再登录系统。'
    },
    noLoginTip: {
      title: '账户锁定提醒',
      content: '由于您6个月内未登录系统，您的账号已被禁用。请您联系管理员恢复账号。',
      tips: '系统已收到您的申请，请等待处理。',
      message: '请求过于频繁,请稍后重试'
    },
    passwordErrorTip: {
      title: '账户锁定提醒',
      content: '您已连续5次输入错误密码，账户已被锁定。请30分钟后再尝试登录。'
    },
    loginDenied: {
      title: '下线通知!',
      content: '您已经在另一个设备上登录了。请在另一个设备退出登录后重试或联系技术支持：{current}'
    },
    resetPwd: {
      title: '下线通知!',
      content: '密码已重置，请重新登录'
    },
    noPermissionTip: {
      title: '提示',
      content: '无权限访问，如果需要访问请联系管理员申请权限'
    },
    loginTimeout: 'Login Timeout',
    reLoginTips: 'Your session has expired, please re-login',
    type: '请选择类型',
    passwordEasy: '密码需为8-30位字符，且包含字母、数字、特殊字符两种以上的组合',
    passwordAgain: '请再次输入密码',
    passwordInput: '请输入密码',
    passwordNotMatch: '两次密码不一致',
    emailRequired: '账号（邮箱）必填',
    emailError: '账号（邮箱）格式不正确·',
    uploadHeadImg: '* 请上传2M以内、JPG/JPEG格式的图片',
    exportTips: '在当前模块，你在过去24小时内只能下载不超过300条数据。',
    inciNotInclude: '该成分暂未收录',
    changePwdSuccess: '密码修改成功，请您重新登录',
    verificationCodeRequired: '验证码需为6位字符',
    goBack: '返回',
    dataNotFound: '数据不存在',
    noAccess: '抱歉，您无权限查看详情',
    moreThanOneYear: '可选择时间区间最大为一年，<br> 您选择的时间区间超过最大限定，请重新选择。',
    permissionChanged: '权限已更改，请刷新页面获取最新权限',
    changedNoPermission: '权限已变更，无权限访问，请退出登录',
    tips: '提示',
    conceptUploadFileTips: '仅支持MP4视频及PDF文件，MP4 < 50 mb，PDF < 20mb',
    uploadImgTips: '仅支持png、jpg、jpeg、bmp图片格式，图片大小<10mb',
    uploadVideoTips: '仅支持MP4视频，MP4 < 50 mb',
    uploadPPTTips: '仅支持PPT文件，PPT < 20 mb',
    uploadPDFTips: '仅支持PDF文件，PDF < 20 mb',
    uploadWatermarkTips: '上传成功，但该PDF已加密，无法生成水印',
    cookiesTis: 'Cookies 帮助我们提供服务。如您使用我们的服务，即表示您同意我们使用 cookies。',
    learnMore: '了解更多',
    items: '项',
    downloadQuota: 'You have exceeded the maximum daily download quota. Please contact Admin or try again later. Thank you.',
    deleteDraftTips: '你确定要删除此草稿吗？',
    operateFail: '操作失败'
  },
  txt: {
    formulationComment: '评论',
    messageCenter: '消息中心',
    desc: '降序',
    asc: '升序',
    noData: '暂无数据',
    noFound: '暂无',
    country: '国 家',
    china: '中 国',
    other: '其 他',
    language: '语 言',
    new: '最新',
    hot: '最热',
    yes: '是',
    no: '否',
    moreThan10000: '如果查询结果大于一万，只展示前一万条数据.',
    // dataSource1: '*数据来源：Euromonitor',
    // dataSource2: '*数据来源: Beauty Evolution',
    dataSource1: '',
    dataSource2: '',
    currentPriceBased1: '现行汇率：2021年固定汇率。',
    currentPriceBased2: '现行汇率：2019年固定汇率。2019-2023年数据为预测数据',
    pricePosition: '*价格定位基于所有品牌产品价格。',
    relatedClicks: '所有与点击相关的数据从2018年4月开始。',
    advancedSearch: '高级搜索',
    brand: '品 牌',
    product: '产 品',
    formulation: '配 方',
    claims: '宣 称',
    claim: '宣 称',
    similarClaim: '相似宣称',
    total: '总共',
    total2: '总 计: ',
    records: '条记录',
    sortBy: '排 序',
    releaseYear: '发行年',
    functionClaim: '功效宣称',
    year: '年 份',
    date: '日 期',
    segment: '市场分类',
    subSegment: '市场二级分类',
    marketSegment: '市场分类',
    category: '分 类',
    productName: '产品名称',
    categories: '分类',
    click: '点击量',
    favorite: '收藏量',
    writeComment: '填写你的评论',
    commentScore: '评分',
    comment: '评论数',
    comments: '评论',
    commentTarget: '评论对象',
    commentTime: '评论时间',
    expertComment: '是否是专家评论',
    Level1commentId: '一级评论ID',
    claimsForm: '宣称/形态',
    claimsSubCategory: '宣称/品类二级分类',
    retailPrice: '零售价格',
    insertPriceRange: '价格范围',
    currency: '货币',
    searchFor: '搜索关键字',
    brandDiscription: '品牌描述',
    productDescription: '产品描述',
    ingredients: '成 分',
    similarBASFFormulations: '相似的配方&产品',
    lucklySimilar: '太好了，为您找到了一些非常相似的配方哟！',
    heyInteresting: '我们找到了一些有意思的配方哦！',
    noFoundSimilar: '未找到结果，我们为什么不去新设计一个呢？',
    tabBasfProduct: '为您找到一些有趣的东西',
    noFoundBasfProduct: '未找到结果',
    lucklyRelated: '太好了！为您找到了一些相关的配方哟！',
    lucklyProducts: '太好了！我们找到了一些非常相似的巴斯夫产品哟！',
    consumerInsight: '市场洞察',
    mayBeInterested: '你可能感兴趣的',
    INCLUDEDTradename: '包含巴斯夫产品',
    INCLUDEDINCI: '包含INCI',
    EXCLUDEDTradename: '不包含巴斯夫产品',
    EXCLUDEDINCI: '不包含INCI',
    INCLUDEDIngredients: '包含的成分',
    EXCLUDEDIngredients: '不包含的成分',
    tags: '标 签',
    title: '配方名称',
    normalTitle: '名称',
    formulationID: '配方ID',
    releaseRegion: '发行地区',
    phase: '阶 段',
    ecoStatus: '环保等级',
    byWeight: '%重量',
    function: '功效',
    specifications: '规 格',
    performance: '性 能',
    manufacturingProcess: '制造工艺',
    whatThink: '告诉我你的想法',
    noComment: '暂无评论',
    ingredient: '成分',
    tradeName: '巴斯夫产品',
    ingredientName: '成分名称',
    CASNumber: '成分备案号',
    registrationCountry: '成分可用国家',
    ingredientsAplicationAnalysis: '成分应用分析',
    moreInformation: '更多信息',
    ingredientCombination: '成分组合',
    functionCombination: '组合后的功效',
    relatedIngredient: '组合的成分',
    relatedFormulation: '相关联的配方',
    similarProduct: '相似的巴斯夫产品',
    percentageCorrelationRatio: '百分比是指相关比',
    combinationRate: '组合比率',
    productInformation: '产品信息',
    brandInformation: '品牌信息',
    selectAll: '全 选',
    basicInformation: '基本信息',
    statements: '声明',
    certificates: '证书',
    MSDS: 'SDS',
    marketingInformation: '市场推广信息',
    marketingInformationPremium: '市场推广信息（俱乐部会员）',
    relatedliterature: '相关联的文献',
    youCanCompare: '最多可比较',
    brandAtMost: '个品牌!',
    productsAtMost: '个产品!',
    formulationAtMost: '个配方!',
    ingredientAtMost: '个成分!',
    addMore: '添 加',
    brand_: '品 牌',
    marketInformation: '市场信息',
    functionalIngredientList: '功效成分列表',
    ingredientList: '成分列表',
    consumerSkinType: '消费者皮肤类型',
    dataSource: '数据源',
    BEVOL: '美丽修行',
    socialMedia: '社交媒体',
    otherWebsite: '其他网站',
    consumerInformation: '用户信息',
    skinType: '皮肤类型',
    gender: '性别',
    consumerArea: '用户地区',
    age: '年 龄',
    priceRange: '价格范围',
    ranking: '排 名',
    previousRank: '上一季排名',
    clickRate: '点击率',
    relatedConcepts: '相关联的概念',
    conceptsFounded: '个概念',
    area: '区 域',
    recentlyViewed: '最近访问',
    yourBrand: '你的品牌',
    previousSelection: '上一个选择',
    previousViewed: '先前预览',
    newFormulationDetail: '新配方详情',
    claimSubstantiation: '宣称证明',
    documents: '文 档',
    prototypeSize: '原型尺寸',
    capacity: '容 量',
    quantity: '数 量',
    additionalClaimsTexturesForms: '（其他宣称、质感、形式…）',
    shippingInformation: '发货信息',
    contactName: '联系人',
    email: '邮 箱',
    companyName: '公司名称',
    address: '地 址',
    prototypeDeliveryOptions: '原型交付选项',
    months: '个月',
    yourOrderPlaced: '您的订单已下达!',
    summary: '概 览',
    BASFContactInformation: 'BASF联系方式',
    myOrderList: '我的订单列表',
    orderId: '订单ID',
    Categorys: '分 类',
    creatTime: '创建时间',
    dashboard: '仪表盘',
    allDataRelated: '所有与点击相关的数据均从2018年4月开始',
    productNumber: '产品数量  ',
    productDetail: '产品详情',
    allResult: '所有结果',
    products: '产 品',
    concepts: '概 念',
    conceptsPremium: '概 念（俱乐部会员）',
    relevantSearchOf: '相关搜索',
    ingridientName: '美修成分',
    document: '文 档',
    lastUpdate: '最后更新时间',
    updateYear: '更新年份',
    conceptsfounded: '个概念。',
    video: '视频',
    videoPremium: '视频（俱乐部会员）',
    scientificDocument: '科学文献',
    relatedConsumerOnsight: '相关消费者洞察',
    relatedBASFFormulation: '相关巴斯夫配方',
    focusedBASFProducts: '相关巴斯夫产品',
    claimsCategory: '宣称/类别',
    province: '省',
    commentsRate: '评论率',
    clicksRate: '点击率',
    PCRMO: '个人护理零售市场概述',
    AsiaPacificView: '亚太视野',
    MapView: '地图视图',
    NOAPEC: '亚太地区和各国的数字',
    EURMillion: '百万欧元',
    clickHere: '点击这里',
    changePassword: '修改密码',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    contactMail: '如果您对我们的系统有任何疑问，请联系我们。邮箱地址：',
    loginInformation: '为了更好的服务，请登录您的信息。',
    targetMarket: '目标市场',
    benchmarkBrand: '对标品牌',
    benchmarkProduct: '对标的消费者产品',
    benchmarkFormu: '对标配方',
    userName: '用户名',
    userRole: '用户角色',
    userGroup: '用户组',
    expertFeedback: '专家评论',
    module: '模 块',
    page: '页 面',
    score: '评 分',
    productDistribution: '产品分布',
    noAuthority: '暂无权限',
    changePasswordTip: '您的密码已到期，请修改密码',
    similarFormulation: '相同宣称的配方',
    interestFormulation: '相同产品形态的配方',
    KeyBASFProduct: '核心巴斯夫产品',
    nothingForYou: 'Emm。。现在什么都没找到，不如我们一起设计一个新的？',
    source: '来源',
    lifestyle: '生活方式',
    keyword: '关键词',
    countryRegion: '地区',
    productFocus: '产品重点',
    brandFocus: '品牌相关',
    targetDemographicCare: '目标人群护理',
    keyWords: '关键词',
    submitBy: '提交人',
    approver: '审核人',
    uploader: '上传人',
    uploadTime: '上传时间',
    platform: '平台',
    feedbackTime: '评论时间',
    approveTime: '审核时间',
    updateTime: '更新时间',
    download: '下载',
    status: '状态',
    file: '文件',
    approveComment: '审核意见',
    allReplies: '全部回复',
    replied: '回复',
    subCategory: '二级分类',
    picture: '主图',
    all: '全部',
    basfProduct: '巴斯夫产品',
    rating: '属性评分',
    trend: '趋 势',
    addConcept: '添加概念 - 文件上传',
    editConcept: '编辑概念 - 文件上传',
    addOldConcept: '添加概念（旧）',
    editOldConcept: '编辑概念（旧）',
    agreement: '使用和许可条款（“条款”）',
    privacy: '数据隐私声明',
    verificationCode: '验证码',
    getCode: '获取验证码',
    checkCode: '请检查电子邮件中的验证码',
    forgetPassword: '忘记密码',
    chooseDate: '选择日期',
    benchmarkFormulation: '对标的巴斯夫配方',
    agreeWithBasf: '我同意并接受巴斯夫',
    legalTitle: '用户条款',
    privacyTitle: '隐私政策',
    sortByInci: '根据上一季度数据排序：',
    newUser: '新用户？',
    qrCodeTips: '请扫描二维码下载App，并使用App注册使用',
    showInFronEnd: '展示',
    commentSetting: '评论审核设置',
    commentApprove: '用户发表的评论，需要在审核通过后才展示',
    containingIngredient: '含有该成分的巴斯夫配方',
    relatedFormulations: '同时含有<span>{inci}</span>和<span>{selectInci}</span>的巴斯夫配方',
    noDataExport: '无数据可导出',
    goTop: '返回顶部',
    default: '默认',
    minutes: '分钟',
    user: '用户',
    role: '角色',
    targetUser: '目标用户',
    targetRole: '目标角色',
    visibleUser: '对所选用户可见',
    invisibleUser: '对所选用户不可见',
    lastActive: '已未活跃天数',
    customize: '自定义',
    delete: '删除',
    preference: '订阅',
    pushStatus: 'PUSH通知',
    statusOff: '关',
    statusOn: '开',
    videoDetail: '视频详情',
    filter: '筛选',
    searchCategory: '搜索此分类',
    channel: '频道',
    specificUserOnly: '仅限特定用户',
    similarConsumerBenefitClaim: '类似宣称的巴斯夫产品',
    similarIngredinet: '成分相似的巴斯夫产品',
    similarFunction: '功能相同的巴斯夫产品',
    formDelivery: '产品形态',
    releasedCountry: '上市国家',
    NA: 'N/A',
    userCenter: '个人中心',
    deleteTips: '您确定您要删除吗？',
    inputUserAccount: '请输入用户',
    inputRoleName: '请输入角色名',
    bevol: '中国美丽修行App',
    duration: '视频时长',
    toxAbstract: '毒理摘要',
    // 品牌属性
    brandProps: {
      brandPositioning: '品牌定位',
      pricePositioning: '价格定位',
      origin: '起源国家',
      retailValue: '销售额',
      marketShare: '市场份额',
      growthRate: '增长率',
      productAmount: '产品数量',
      nature: '天 然',
      technology: '科 技',
      general: '大 众',
      mass: '大众品牌',
      masstige: '中端品牌',
      premium: '高端品牌',
      group: '集 团',
      specificPopulationGroups: '特定人群',
      mainClaim: '主要宣称',
      productsQuantity: '产品数量',
      clicks: '点击量',
      ranking: '排名',
      JPGFormat: '上传头像图片只能是 JPG 格式!',
      pictureSize: '上传头像图片大小不能超过 2MB!',
      brandGroup: '品牌集团',
      officialLink: '官网链接',
      majorCategory: '产品主要分类',
      majorSubCategory: '产品主要二级分类'
    },
    conceptMenu: {
      conceptList: '概念列表',
      Approved: 'Approved',
      pendingApproval: 'Pending Approval',
      Denied: 'Denied',
      Draft: 'Draft'
    },
    // 产品属性
    prodProps: {
      brand: '品 牌',
      productCategory: '产品类别',
      price: '价 格',
      brandOrigin: '品牌起源国家',
      productForm: '产品形态',
      capacity: '容 量',
      market: '市 场',
      applicationArea: '应用区域',
      CFDARegistrationYear: 'NMPA注册年份',
      brandGroup: 'brandGroup',
      dataFromCFDA: 'NMPA备案编号',
      claim: '宣 称',
      mainIngredients: '主要成分',
      functionIngredients: '功效成分',
      clicks: '点击量',
      commentScore: '评 分',
      comments: '评论数',
      rank: '排名',
      manufacture: '工厂',
      launchYear: '商品备案年份',
      internationalType: '备案版本（国际版）',
      CFDAType: '备案版本（中国药监局）',
      versions: '个版本'
    },
    // 配方属性
    fomuProps: {
      country: '生产国家',
      productCategory: '产品类别',
      applicatioArea: '应用区域',
      subApplicationArea: '子应用区域',
      productForm: '产品形态',
      ProductAspect: '产品包装',
      formulationID: '配方ID',
      author: '配方工程师',
      ownerName: '所有者',
      ownerEmail: '所有者Email',
      sunscreenLevel: '防晒等级',
      functionalClaim: '功效宣称',
      emotionalClaim: '情感宣称',
      sensoryClaim: '感官宣称',
      priceRange: '价格范围',
      // boss new formulation
      claims: '宣 称',
      category: '类 别',
      formAspect: '形式/方面',
      sunscreenLevelSPF: '防晒等级SPF',
      sunscreenLevelPA: '防晒等级PA',
      specificPopulationGroups: '特定人群',
      insertPriceRange: '价格范围',
      applicationArea: '应用区域',
      BASFFormulation: '巴斯夫配方',
      productBenchmark: '对标产品',
      currency: '货币',
      subArea: '适用部位',
      BASFProposedFormulation: '巴斯夫建议配方',
      ingredients: '成 分',
      releaseRegion: '发行地区'
    },
    // 美修成分属性
    ingrdProps: {
      among: '所有成分的',
      category: '产品分类',
      function: '功效',
      functionalClaim: '使用目的',
      CASNumber: '成分备案号',
      clicks: '点击',
      relatedTradeName: '相关联的巴斯夫产品',
      favorites: '收藏',
      registrationArea: '成分可用国家',
      comments: '评论',
      subCategory: '二级分类',
      click: 'Bevol点击量',
      userClick: 'DlitE3X点击量',
      productAmong: '含有成分的商品数',
      bevolClicks: '上季度点击数（Bevol）',
      dlite3Clicks: '上季度点击数（D’litE3X）',
      productCount: '上季度含有该成分的产品数',
      rateTips: 'Rate=筛选条件下，含有该成分的产品数/总产品数'
    },
    // 巴斯夫成分属性
    tradeProps: {
      Number: '序号',
      PRDNumber: 'PRD号',
      ownerName: '所有者',
      ownerEmail: '所有者Email',
      formDelivery: '形态',
      function: '功效',
      application: '应用领域',
      productGroup: '产品分组',
      consumerBenefit: '用户宣称',
      INCIID: '成分ID',
      INCIName: '成分名称',
      bMark: 'B mark',
      eco_Status: '环保等级',
      releasedCountry: '发布国家',
      valueProposition: '产品介绍',
      submittedBy: '上传人',
      competitor: '相关联的巴斯夫竞品',
      basfProductName: 'BASF产品名称',
      warningCarefully: '本页面的信息的修改会影响到全局，请谨慎操作！',
      consumerBenefitTips: '最多可选20条用户宣称',
      toBeConfirmed: '待确认',
      usedInBASFName: '在巴斯夫产品中使用',
      uploadResult: '上传BASF Mark结果',
      downloadResult: '下载上传结果',
      uploadFile: '上传文件',
      changeFile: '修改文件',
      uploadTips: '请使用导出的文件模版来上传BASF Mark结果',
      uploadSuccess: '导入成功',
      uploadFailure: '导入失败',
      resultTips: '系统将自动为您下载上传的结果，或者您可以点击下方按钮直接开始下载。',
      uploadRequire: '上传失败，请上传符合要求的excel文件',
      searchFor: '搜索',
      moreFilter: '更多筛选',
      resetFilter: '重置筛选',
      qdName: 'QD Name',
      qdNameTips: 'QD Name仅在日文版本显示',
      displayQDName: '显示QD Name',
      addToCart: '加入购物车',
      yourInformation: '您的信息',
      cartIsEmpty: '请先添加巴斯夫产品至购物车',
      items: '项',
      BASFProductList: 'BASF Product list',
      additionalRequests: '对其他产品的补充要求',
      additionalRequestsTips: '请说明其他产品或要求',
      languageTips: '选择在哪种语言环境下展示'
    }
  },
  searchMenu: {
    brand: '品 牌',
    product: '产 品',
    formulation: '配 方',
    ingredient: '成 分',
    concept: '概 念',
    basfProduct: '巴斯夫产品',
    general: '综合查询',
    event: '活动'
  },
  menu: {
    brand: '品牌分析',
    product: '消费者产品',
    formulation: '配方设计',
    ingredient: '成分筛选',
    concept: '概念',
    consumer: '市场洞察',
    boss: 'BOSS',
    video: '介绍视频',
    dataManagement: '数据管理',
    dataUpload: '数据上传',
    dataRelationship: '数据关系管理'
  },
  breadCrumb: {
    home: '首 页',
    brand: '品牌分析',
    brandDetail: '品牌详情',
    boss: 'BOSS',
    comprehensiveSearch: '综合查询',
    advancedSearch: '高级搜索',
    formulationNewDesign: '配方新设计',
    purchase: '购 买',
    myOrder: '我的订单',
    consumerProducts: '消费者产品',
    consumerProductsDetail: '产品详情',
    productComparison: '产品比较',
    brandComparison: '品牌比较',
    formulationComparison: '配方比较',
    ingredientComparison: '成分比较',
    ingredientSelection: '成分筛选',
    formulationDesign: '配方设计',
    formulationDetail: '配方详情',
    ingredientDetail: '成分详情页',
    tradeNameDetail: '巴斯夫产品详情页',
    consumerInsights: '市场洞察',
    trend: '趋势',
    trendList: '趋势列表',
    trendDetail: '趋势详情页',
    marketOverview: '市场概况',
    topRanking: '排行榜',
    conceptsCollection: '概念',
    newConceptsList: '新概念集',
    oldConceptsList: '旧概念集',
    viewMore: '查看更多',
    euperlanOPWhite: 'Euperlan ®  OP White',
    orderDetail: '订单详情',
    bossProduct: '产 品',
    conceptDetail: '概念集详情',
    BASFProduct: '巴斯夫产品管理',
    BASFProductUpload: '巴斯夫产品上传',
    formulation: '配方管理',
    formulationUpload: '配方上传',
    trendManagement: '趋势管理',
    trendUpload: '趋势上传',
    concept: '概念管理',
    conceptUpload: '概念上传',
    accounts: '账号管理',
    role: '角色管理',
    userBehavior: '用户行为分析',
    feedback: '反馈',
    commentData: '评论数据',
    visitData: '访问数据',
    lifestyleSegment: '趋势分类管理',
    event: '活动管理',
    eventSpeaker: '演讲者',
    eventFormulationCategory: '配方分类',
    eventFormulation: '配方',
    eventProductCategory: '巴斯夫产品分类',
    eventSolution: '解决方案',
    eventProduct: '巴斯夫产品',
    webinar: '线上研讨会',
    introVideo: '网络教学',
    introVideoList: '网络教学管理',
    care: '详情',
    topManagement: '排行榜-其他网站',
    productDetail: 'Add Product',
    sourceDetail: 'Edit Source',
    formuCategory: 'Formulation - Category',
    formuProduct: '配方产品管理',
    userGroup: '用户组管理',
    message: '消息中心',
    aboutBASF: '关于巴斯夫',
    appPictures: '全部图片',
    topRrankingSourceIndexstatus: 'Edit Source',
    otherWebsiteEditProductStatus: 'Edit product',
    delivery: '运输形态',
    application: '应用领域',
    benefit: '消费者权益',
    productGroup: '产品组',
    inciBasfMark: '成分B标签管理',
    competitor: '其他公司的产品',
    claim: '宣称管理',
    brandClaim: '品牌宣称',
    formfunction: '功效',
    messageCenter: '消息中心',
    coownerSetting: 'Co-owner setting',
    activityLog: 'Activity Log',
    announcement: 'Announcement',
    technicalSupport: '技术支持',
    whiteList: 'White List',
    orderList: '订单列表',
    qrCode: 'QR Code',
    dliteFunction: "D'litE成分功效",
    basfFunction: '巴斯夫产品功效',
    bevolFunction: 'Bevol成分功效',
    inciManagement: '成分',
    userPortrait: '用户画像',
    visitDataAnalysis: '访问数据分析',
    push: 'PUSH Management',
    media: '视频',
    tagSearch: '视频标签',
    homePage: '首页',
    globalPage: 'D\'litE3X Global',
    myProfile: '个人资料',
    commentKeywords: '评论关键词',
    eventTrend: '趋势',
    eventConcept: '概念',
    eventClient: '活动',
    eventDetail: '活动详情',
    webinarClient: '线上研讨会',
    webinarDetail: '线上研讨会详情',
    blackList: '黑名单',
    deeplink: '深度链接',
    keywordLibrary: '关键词库'
  },
  // 图表
  chart: {
    retailValue: '销售额',
    marketShare: '市场份额',
    CAGR: '复合年均增长率',
    growthRate: '增长',
    rate: '比率',
    number: '数量',
    // 品牌模块
    brand: {
      // List页面
      BPM: '品牌定位（零售价值和增长率）',
      T5PC: '五大热门宣称品牌分布',
      CPD: '商品品类品牌分布',
      T10CCP: '热门宣称&分类下的品牌分布',
      // detail --> Market Data
      BRVMS: '品牌零售价与市场份额',
      BRVGR: '品牌零售价与增长率',
      MS: '市场份额',
      // detail --> Basic Data
      clicks: '点击量',
      comments: '评论数',
      PDBC: '产品类别分布',
      // detail --> 产品和宣称
      T5CALP: '最热门五大产品宣称年度分布',
      T3BNL: '三大全新发布',
      ALPD: '品牌产品年度发布分布',
      APD: '品牌产品年度分布',
      ALPCD: '品牌产品类别年度发布分布',
      T10P: '十大产品',
      // detail --> 成分和消费者反馈
      IUT: '成分使用趋势',
      AD: '年度消费者画像',
      CC: '点击分布',
      CL: '地域分布',
      CST: '肤质分布',
      CG: '性别分布',
      rateTips: 'Rate=筛选条件下，含有该成分的产品数/总产品数',
      top5ClaimsTips: '最近6年新发布产品中使用最多的5个宣称<br />最近3年新发布产品中使用最多的5个宣称',
      productLaunchYear: '备案年份',
      year: '年份',
      season: '季度',
      dbClickTips: '双击选中区域查看详情'
    },
    product: {
      // list
      T10CPF: '最热门十大宣称产品形态分布',
      T10CSC: '最热门十大宣称产品市场分类分布',
      T10PDCF: '最热门前10产品宣称产品形态分布',
      T10PDCC: '最热门前10产品宣称产品市场分布',
      // detail
      FA: '评论消费者画像',
      CCL: '地区分布',
      HL: '地区分布',
      T10C: '前十词频分布',
      CCST: '皮肤类型分布',
      CCA: '年龄分布',
      Clicks: '点击分布',
      Location: '地域分布',
      ST: '肤质分布',
      Age: '年龄分布',
      productClaimLandscape: '产品宣称情况',
      // dashboard
      MPCT10: '上个月点击数top10的商品',
      IUTTVLM: '使用趋势TOP10的成分与总计相比',
      MBCT10: '上个月品牌商品点击数top10的品牌',
      ANLCD: '年度新产品宣称分布',
      ANP: '年度新产品数量分布'
    },
    ingredient: {
      products: '成分使用分析',
      byCategory: '按类别',
      T10PCZO: '十大产品 ',
      IUT: '成分使用趋势'
    },
    insight: {
      T10C: '前10宣称',
      PCRMO: '个人护理零售市场概述',
      SRVGR: '产品分类零售额与增长率',
      SSRVGR: '产品分类分区零售额与增长率',
      T10CBRVMS: '十大公司/品牌销售量和市场份额分布',
      CBP: '公司/品牌绩效',
      amongBrand: '所有品牌的 Top xx%',
      amongProduct: '所有产品的 Top xx%'
    }
  },
  // 按钮名称
  btn: {
    login: '登 录',
    register: '注 册',
    forgetPassword: '忘记密码',
    changePassword: '修改密码',
    add: '添加',
    yes: '确 定',
    apply: '提 交',
    cancel: '取 消',
    ok: '确定',
    send: 'Send',
    order: '我的订单',
    search: '搜 索',
    submit: '提 交',
    reply: '回复',
    confirm: '确 定',
    week: '周',
    month: '月',
    collapse: '收起',
    viewAll: '查看全部',
    feedback: '反馈',
    year: '年',
    exportAllResult: '导出所有文档',
    addToCompare: '添加比较',
    downloadPDF: '下载PDF文件',
    downloadPPT: '下载PPT文件',
    askForNewDesignBenchmark: '参照设计',
    askForNewDesign: '新的设计',
    addFomulationCompare: '添加到配方比较',
    export: '导 出',
    confirmationSubmission: '确认提交',
    AddMoreBrand: '添加品牌',
    AddMoreProduct: '添加产品',
    AddMoreFormulation: '添加配方',
    AddMoreIngredient: '添加成分',
    hide: '隐 藏',
    viewMore: '查看更多',
    forProducts: '产品排行榜',
    forClaims: '宣称排行榜',
    forBrand: '品牌排行榜',
    forGroup: '集团排行榜',
    advancedSearch: '高级搜索',
    purchase: '购 买',
    viewMoreConcepts: '查看更多概念',
    trend: '趋 势',
    marketOverview: '市场概况',
    topRanking: '最高排名',
    reset: '重 置',
    resetPassword: '重置密码',
    confirmResetPassword: '确认重置密码吗？',
    previousStep: '上一步',
    previous: '上一步',
    back: '上一步',
    nextStep: '下一步',
    changeAvatar: '修改头像',
    technicalSupport: '技术支持',
    newConcepts: '新概念集',
    oldConcepts: '旧概念集',
    edit: '编辑',
    pendingCheck: '审核',
    withdraw: '撤回',
    approve: '审核通过',
    deny: '审核不通过',
    view: '详情',
    preview: '预览',
    draft: '保存草稿',
    change: '修改',
    upload: '上传',
    uploadFile: '上传文件',
    enable: '启用',
    disable: '停用',
    set: '设置',
    sendApplication: '恢复账号',
    contactUs: '联系我们',
    contactUsByEmail: '需要技术支持请联系{current}',
    refresh: '刷新',
    signOut: '退出'
  },
  statusTab: {
    allApproved: '所有已通过',
    allPending: '所有审核中',
    allDenied: '所有被驳回',
    approved: '已通过',
    pending: '审核中',
    denied: '被驳回',
    draft: '草稿箱'
  },
  // 下拉框选项
  select: {
    clicks: '点击量',
    favorite: '收藏量',
    comments: '评论数',
    byClicks: '点击量',
    byFavorites: '收藏量',
    byComments: '评论数',
    female: '女 性',
    male: '男 性',
    dryRigid: '干性-耐受',
    drySensitive: '干性-敏感',
    oilyRigid: '油性-耐受',
    oilySensitive: '油性-敏感',
    standard: '标 准',
    express: '特 快',
    updateTime: '更新时间'
  },
  tabs: {
    // brand
    briefAnalysis: '简要分析',
    brandList: '品牌列表',
    // brand --> brand detail
    marketData: '市场数据',
    basicData: '基础数据',
    productsClaims: '产品和宣称',
    ingredientsConsumer: '成分和消费者',
    brandGroup: '品牌集团'
  },
  // 输入框提示
  placeholder: {
    username: '请输入用户名',
    password: '请输入密码',
    keyword: '请输入关键词',
    keyWords: '关键词',
    year: '请选择年',
    country: '请选择国家',
    segment: '请选择市场分类',
    subSegment: '请选择市场二级分类',
    age: '请输入年龄',
    priceRange: '请输入价格区间',
    to: '至',
    start: '开始日期',
    end: '结束日期',
    brandSearch: '品牌搜索',
    category: '请选择分类',
    brandGroup: '请选择品牌集团',
    brandPositioning: '请选择品牌定位',
    pricePositioning: '请选择价格定位',
    function: '请选择功效',
    functionClaim: '请选择功效宣称',
    brand: '品 牌',
    productForm: '产品形态',
    productAspect: '产品包装',
    sunscreenLevelSPF: '防晒等级-SPF',
    sunscreenLevelPA: '防晒等级-PA',
    specificPopulationGroups: '特定人群',
    applicationArea: '应用区域',
    subArea: '二级领域',
    functionalClaim: '功效宣称',
    emotionalClaim: '情感宣称',
    sensoryClaim: '感官宣称',
    tradename: '巴斯夫产品',
    INCI: 'INCI',
    tags: '标 签',
    registeredCountry: '成分可用国家',
    formDelivery: '交货形式',
    ecoSatus: '环保等级',
    skinType: '请选择皮肤类型',
    gender: '请选择性别',
    province: '请选择省份',
    consumerArea: '请选择用户地区',
    search: '搜 索',
    INCLUDEDIngredients: '请输入包含的成分',
    EXCLUDEDIngredients: '请输入不包含的成分',
    capacity: '请选择容量',
    quantity: '请选择数量',
    pleaseEnterContent: '请输入内容',
    contactName: '请输入联系人',
    email: '请输入邮箱',
    companyName: '请输入公司名称',
    address: '请输入地址',
    activeIngredient: '活性成分',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    commentsHere: '请在此处评论',
    source: '来源',
    lifestyle: '生活方式',
    targetDemographicCare: '目标人群护理',
    productFocus: '产品重点',
    sortBy: '排序',
    language: '语言',
    countryRegion: '区域',
    submitBy: 'Submit By',
    approver: 'Approver',
    uploader: 'Uploader',
    operation: '操作',
    type: '类型',
    pleaseSelect: '请选择',
    brandGroupSearch: '品牌集团搜索'
  },
  validate: {
    username: {
      require: '请输入帐号'
    },
    password: {
      require: '请输入密码'
    },
    email: {
      required: '请输入E-mail',
      pattern: 'E-mail格式不正确'
    },
    ownerName:{
      require: '请输入所有者'
    },
    emailLength: '邮箱长度不能超过50字符'
  },
  legend: {
    thisMonth: '本 月',
    overall: '总 计',
    OR: '油耐',
    OS: '油敏',
    DR: '干耐',
    DS: '干敏',
    NA: 'Not Answered'
  },
  series: {
    skinType: '皮肤类型'
  },
  compare: {
    brand: '品 牌',
    product: '产 品',
    formulation: '配 方',
    ingredient: '成 分'
  },
  trend: {
    name: '名称',
    ownerName: '所有者',
    ownerEmail: '所有者Email',
    pictureNeeded: '请先上传主图',
    picture: '主图',
    country: '地区',
    addFile: '添加文件',
    largeFile: '文件不得超过',
    add: '添加新的趋势',
    addLifestyle: '添加生活方式',
    addKeyword: '添加关键词',
    addSegment: '添加分类',
    editLifestyle: '编辑生活方式',
    editKeyword: '编辑关键词',
    editSegment: '编辑分类',
    edit: '编辑趋势',
    basic: '基本信息',
    attribute: '特征信息',
    keyword: '关键词',
    approve: '审核趋势',
    preview: '预览趋势',
    position: '位置',
    trendName: '名称',
    trending: '最新趋势',
    addTrending: '添加到最新趋势',
    weight: '权重',
    rate: '评分',
    webView: 'Web 浏览量',
    APPView: 'APP 浏览量',
    allRequired: '请完成所有必填项',
    pdfNppt: 'PPT 和 PDF 至少传一项',
    user: '指定用户',
    userGroup: '指定用户组',
    userTips: '说明: 如果需要指定人员可以查看这个趋势，请选择目标用户和用户群；如果不选，则视为全部用户可查看',
    videoTips: '*Only MP4 for video is supported. MP4 < 50mb',
    video: '视频',
    videoPicture: '视频封面图',
    trend: '趋势',
    trendPremium: '趋势（俱乐部会员）',
    filePremium: '文件（俱乐部会员）',
    videoPremium: '视频（俱乐部会员）',
    videoPicturePremium: '视频封面图（俱乐部会员）',
    fileInternal: '文件（内部内容）',
    videoInternal: '视频（内部内容）',
    videoPictureInternal: '视频封面图（内部内容）',
    premiumTips: '如果您需要上传趋势文件，请确保上传一份PDF文件',
    trendFileTips: '请上传趋势文件',
    description: '描述',
    trendInternal: '趋势（内部）',
    trendFile: '趋势文件',
    trendFileClub: '趋势文件（俱乐部会员）',
    trendFileInternal: '趋势文件（内部）',
    productFocus: '产品焦点',
    targetDemographicCare: '目标人口'
  },
  formulation: {
    add: '添加新配方',
    edit: '编辑配方',
    addChineseFormulation: '添加中文配方',
    subTitle: '子标题',
    form: '形态',
    view: '详情',
    approval: '审核',
    uploadFile: '上传文件',
    uploadImage: '上传图片',
    enUploadFile: '上传英文配方文件',
    enTitle: '标题（英文）',
    enSubTitle: '子标题（英文）',
    updatePdfFail: '文件上传失败，请上传正确的PDF文件',
    updateImageFail: '图片上传失败，请上传正确的图片文件',
    extract: '解析',
    inputEmpty: '输入信息不能为空',
    extractPDF: '请先解析PDF文档',
    extractFailed: '解析失败。 <br />请重新上传。',
    disableFormulation: '你确定调整以下配方状态为 <strong>不可用</strong> ?',
    enableFormulation: '你确定调整以下配方状态为 <strong>可用</strong> ?',
    formulationID: '配方ID',
    titleEnglish: '标题（英文）',
    titleChinese: '标题（中文）',
    titleJapanese: '标题（日文）',
    title: '标题',
    subCategory: '二级分类',
    SPF: '防晒等级-SPF',
    PA: '防晒等级-PA',
    uploadPDFEnglish: '上传PDF（英文）',
    uploadPDFChinese: '上传PDF（中文）',
    uploadPDFJapanese: '上传PDF（日文）',
    views: '查看',
    subTitleChinese: '子标题（中文）',
    subTitleEnglish: '子标题（英文）',
    subTitleJapanese: '子标题（日文）',
    descriptionEnglish: '描述（英文）',
    descriptionChinese: '描述（中文）',
    descriptionJapanese: '描述（日文）'
  },
  topRanking: {
    brand: '品牌名称',
    product: '产品名称',
    productTips: 'Rate指所有产品的Top xx%',
    brandTips: 'Rate指所有品牌的Top xx%',
    dataSource: '数据源',
    bevol: '美丽修行',
    others: '其他',
    topClaims: '宣称排行榜',
    topProducts: '产品排行榜',
    topBrands: '品牌排行榜',
    topIngredients: '成分排行榜',
    showFilters: '展开筛选器',
    hideFilters: '收起筛选器',
    quater: '季度',
    referenceDate: '参考时间',
    comparisonDate: '比较时间',
    rankingRules: '排名规则',
    productInformation: '产品信息',
    category: '分类',
    priceRange: '价格范围',
    consumerInformation: '用户信息',
    consumerLocation: '用户地区',
    skinType: '皮肤类型',
    gender: '性別',
    age: '年齢',
    brandInformation: '品牌信息',
    brandGroup: '品牌集团',
    brandPositioning: '品牌定位',
    pricePositioning: '价格定位',
    ingredientInformation: '成分信息',
    function: '功效',
    functionalClaim: '使用目的',
    releaseLocations: '成分可用国家',
    top10Claims: '前10宣称',
    top10Products: '前10产品',
    ranking: '排名',
    productName: '产品',
    brandName: '品牌',
    click: '点击量',
    comment: '评论数',
    favorite: '收藏量',
    top10Ingredients: '前10成分',
    top10Brands: '前10品牌',
    relatedFormulation: '相关巴斯夫配方',
    relatedConcept: '相关概念',
    mostlyUsed: '与<span style="color: #21BDBB; font-size: 14px;">“{current}”</span>共用最多次的宣称',
    mostlyUsedTips: '当前选中宣称所属的商品里，共用最多次的宣称',
    filter: '筛选器',
    date: '时间'
  },
  comment: {
    trend: '你觉得这个趋势满足你的需要了么？',
    concept: '你觉得这个概念满足你的需要了么？',
    consumerProduct: '你觉得这个产品满足你的需要了么？',
    formulation: '你觉得这个配方满足你的需要了么？',
    product: '你觉得这个产品满足你的需要了么？',
    inci: '你觉得这个成分满足你的需要了么？',
    eLearning: '你觉得这个eLearning满足你的需要了么？',
    brand: '你觉得这个品牌满足你的需要了么？'
  },
  webinar: {
    day: '天',
    viewed: '预览',
    segment: '市场分类',
    speaker: '演讲者',
    addNewWeb: '添加新的交流视频',
    editWeb: '编辑交流视频',
    webTitle: '交流视频名称',
    subscriberEmailList: '订阅邮箱清单',
    keyTopic: '主题',
    keyVisual: '首页主图',
    representative: '巴斯夫代表',
    submissionTime: '提交时间',
    start: '开始于',
    inTime: '中国香港时间',
    picture: '主图',
    title: '标题',
    speakerTitle: '演讲者头衔',
    speakerName: '演讲者名称和头衔',
    speakerPicture: '演讲者照片',
    learnMore: '了解更多巴斯夫解决方案',
    forumWelcome: '巴斯夫论坛欢迎您',
    contactRepresentative: '联系您的巴斯夫代表或订阅以获取及时咨询',
    yourEmail: '你的邮箱',
    basfRepresentative: '巴斯夫代表',
    exploreMoreConcepts: '查看更多概念',
    pdfTitle: 'PDF文件标题',
    pdfFile: 'PDF文件',
    pdfImage: 'PDF前端图片',
    videoTitle: '视频文件标题',
    videoFile: '视频文件',
    videoImage: '视频前端图片',
    tips: '小提示',
    reallyChangeStatus: '是否确认修改状态？',
    addNewVideo: '添加新的视频',
    editNewVideo: '编辑新的视频',
    editVideo: '编辑视频',
    firstPlace: '将此活动添加至第一位',
    add: '添加',
    webinarTitle: '标题',
    sortBy: '排序',
    startTime: '开始时间',
    createTime: '创建时间',
    clickHere: '想要样本吗？点击这里！',
    choose: '选择请求样本',
    request: '请求样本项',
    submitRequest: '提交请求',
    items: '项',
    email: '邮箱',
    telephone: '电话号码',
    additionalRequests: '其他请求',
    addSuccessfully: '已成功添加',
    experience: 'We’d love to hear from you about your webinar experience!',
    goToParticipate: '前往参加',
    leaveUs: '如有任何疑问，请在此留言！',
    type: 'Type',
    feedback: 'Feedback',
    content: 'Content',
    successfulFeedback: '成功提交反馈',
    materials: '研讨会的内容重点及相关资讯',
    sampleRequest: '获取样品',
    detail: '详情',
    creator: '创建人',
    fillInSurvey: '填写问卷',
    viewRelatedContents: '查看相关内容',
    postalCode: '邮编',
    forJapanese: '日本用户必须填写'
  },
  pager: {
    total: '总共',
    results: '条记录',
    searchResult: '搜索结果:'
  },
  concept: {
    new: '新',
    old: '旧',
    year: '年 份',
    addOldConcept: '添加旧类型的概念',
    addNewConcept: '添加新类型的概念',
    uploadPicture: '上传图片',
    pictureRequire: '图片:（图片尺寸：16：9）',
    fileRequire: '文件:（图片尺寸：16：9）',
    fileLimit: '只支持上传MP4和PDF格式的文件。MP4文件<50mb，PDF文件<20mb',
    fileName: '文件名',
    basfProductPrd: 'Basf Product Prd',
    basfProductName: '巴斯夫产品名称',
    approved: '审核通过',
    approval: '审 核',
    pendingApproved: '待审核',
    denied: '审核不通过',
    draft: '我的草稿',
    country: '国 家',
    type: '类 型',
    segment: '市场分类',
    updateYear: '更新年份',
    approver: '审核人',
    submitBy: '提交人',
    newConcept: '是否设定为新',
    search: '搜 索',
    name: '名 称',
    uploadTime: '上传时间',
    regionCountry: '地区',
    rate: '评 分',
    webView: 'Web 浏览量',
    appView: 'APP 浏览量',
    set: '设 置',
    operation: '操 作',
    approveTime: '审核时间',
    updateTime: '更新时间',
    editOldConcept: '编辑旧类型的概念',
    conceptName: '概念名称',
    conceptNameCn: '概念名称（中文）',
    conceptNameEn: '概念名称（英文）',
    conceptNameJp: '概念名称（日本語）',
    ownerName: '所有者',
    ownerEmail: '所有者Email',
    oldFile: '旧类型的文件',
    cancel: '取 消',
    submit: '提 交',
    picture: '主 图',
    language: '语 言',
    files: '文 件',
    uploadFile: '上传文件',
    saveAsDraft: '保存草稿',
    next: '下一步',
    conceptPdf: '概念pdf文件',
    premiumTips: '俱乐部会员内容只对DlitE3X Club用户开放，而不对DlitE3X Lite用户开放（即免费用户）。',
    internalTips: '内部内容将只开放给DlitE3X内部用户，但不向DlitE3X外部用户开放。',
    conceptPdfPremium: '概念pdf文件（俱乐部会员）',
    conceptPdfInternal: '概念pdf文件（内部）',
    editNewConcept: '编辑新类型的概念',
    information: '信息',
    video: '视 频',
    videoPremium: '视 频（俱乐部会员）',
    videoInternal: '视 频（内部）',
    scientficDocumentPdf: '科学文献PDF文件',
    trendPdf: '趋势PDF',
    consumerInsightPdf: '消费者洞察PDF文件',
    ClaimPerformance: '功效/宣称',
    back: '上一步',
    relatedFormulation: '相关配方',
    relatedBasfProduct: '相关巴斯夫产品',
    preview: '预 览',
    chooseFile: '选择文件',
    change: '修 改',
    view: '预 览',
    relatedClaims: '关联的宣称',
    formulationId: '配方ID',
    trendTitle: '趋势标题',
    formulationName: '配方名称',
    relatedConcept: '相关概念',
    relatedConceptPremium: '相关概念（俱乐部会员）',
    relatedConceptInternal: '相关概念（内部）',
    relatedScientificDocument: '相关科学文献',
    relatedTrend: '相关趋势',
    relatedConsumerInsight: '相关消费者洞察',
    previous: '上一步',
    antiAnce: '',
    approvalComment: '审核评论',
    edit: '编 辑',
    withdraw: '撤 回',
    setNewConcept: '设置新类型的概念',
    setToNewConcept: '添加到最新的概念',
    weight: '权 重',
    notice: '通知',
    export: '导 出',
    selectClaim: '请选择宣称',
    selectFile: '请选择文件',
    userTips: '说明: 如果需要指定人员可以查看这个概念，请选择目标用户和用户群；如果不选，则视为全部用户可查看',
    missPicOrName: '缺少图片或图片名',
    missFileName: '缺少文件名',
    missFile: '必须上传文件',
    fileLang: '文件语言',
    languageTips: '选择在哪种语言环境下展示',
    top10BASFProduct: '十大最热门巴斯夫产品',
    top10Formulation: '十大最热门配方',
    exportData: '导出数据',
    underConstruction: '正在开发中',
    keyWord: '关键词',
    location: '地区',
    views: '浏览量',
    relatedBASFFormulation: '相关巴斯夫配方',
    relatedPerformance: '功效/宣称',
    clickToView: '点击查看',
    top10BASFProductFormulation: '十大最热门巴斯夫产品&配方',
    dlite3Pick: 'D’litE³™X精选',
    specificUserOnly: '仅限特定用户',
    enDescription: '描述（英文）',
    cnDescription: '描述（中文）',
    jpDescription: '描述（日本語）',
    relatedKalturaVideo: '关联kaltura视频',
    inputkalturaVideoTitle: '输入kaltura视频标题',
    conceptInternal: '概 念（内部）'
  },
  event: {
    NO: '序号',
    eventName: '活动名称',
    eventStatus: '活动状态',
    Type: '类型',
    startDate: '开始时间',
    endDate: '结束时间',
    Speaker: '演讲者',
    Formulation: '配方名称',
    BASFProductCategory: '巴斯夫产品分类',
    BASFProduct: '巴斯夫产品',
    Solution: '解决方案',
    status: '状态',
    Operation: '操作',
    View: '详情',
    Edit: '编辑',
    Online: '线上',
    Offline: '线下',
    QRCode: '查看二维码',
    export: '导出数据',
    AddNewEvent: '添加活动',
    speakername: '演讲者名称',
    speakerpicture: '演讲者照片',
    spearkerTitle: '演讲者头衔',
    Weight: '权重',
    SolutionName: '解决方案名称',
    SolutionFile: '解决方案文件',
    Clicks: '点击数',
    TimeAddress: '时间和地址',
    ProductName: '产品名称',
    ProductID: '产品ID',
    OPPFile: 'OPP 文件',
    Category: '分类',
    Segment: '分类',
    Ratings: '评分',
    FormulationName: '配方名称',
    FormulationID: '配方ID',
    MainPicture: '主图',
    FormulationFile: '配方文件',
    EventSegment: '活动分类',
    AddFormulationCategroy: '添加配方分类',
    FormulationCategory: '配方分类',
    CategoryPicture: '分类主图',
    Editevent: '编辑活动',
    Addevent: '添加活动',
    Welcomewords: '欢迎词',
    Eventkeyvisual: '活动主图',
    Time: '时间',
    EditFormulation: '编辑配方',
    AddFormulation: '添加配方',
    SubCategory: '二级分类',
    FunctionalClaim: '功效宣称',
    CommentKeyWords: '评论关键词',
    Editformulationcategory: '编辑配方分类',
    Addformulationcategory: '添加配方分类',
    CategoryName: '分类名称',
    EditProduct: '编辑产品',
    AddProduct: '添加产品',
    BASFProductID: '巴斯夫产品ID',
    BASFProductName: '巴斯夫产品名称',
    BASFProductOPPFile: '巴斯夫产品OPP文件',
    Claims: '宣称',
    INCI: '成分',
    Formofdelivery: '形态',
    ecostatus: '环保指数',
    Function: '功效',
    EditBASFProductCategory: '编辑巴斯夫产品分类',
    AddBASFProductCategory: '添加巴斯夫产品分类',
    EditSolution: '编辑解决方案',
    AddSolution: '添加解决方案',
    Solutionname: '解决方案名称',
    Picture: '主图',
    Solutionfile: '解决方案文件',
    EditSpeaker: '编辑演讲者',
    AddSpeaker: '添加演讲者',
    SpeakerName: '演讲者名称',
    SpeakerTitle: '演讲者头衔',
    SpeakerPicture: '演讲者照片',
    File: '文件',
    Venue: '地址',
    Organizer: '组织者',
    FormulationSegment: '配方分类',
    keyWordsMsg: '请以逗号分隔不同关键词',
    Target: '目标用户',
    TargetGroup: '目标用户组',
    creator: '创建人',
    CreationTime: '创建时间',
    Modifier: '修改人',
    ChangeTheTime: '修改时间',
    Description: '如果需要指定人员参与活动，请选择目标用户和用户群；如果不选，则视为全部用户可参与. ',
    DescriptionSpan: '说明',
    segmentPicture: '分类图片',
    trend: '趋势',
    trendName: '趋势名称',
    addTrend: '添加趋势',
    editTrend: '编辑趋势',
    concept: '概念',
    conceptName: '概念名称',
    addConcept: '添加概念',
    editConcept: '编辑概念',
    title: '标题',
    exportEventList: '导出活动列表',
    exportParticipantData: '导出参与者数据',
    exportVisitData: 'Export visit data',
    exportCommentData: '导出评论数据',
    exportDownloadData: '导出下载数据',
    recommendedSize: '建议尺寸',
    recommendedRatio: '建议比例',
    kalturaVideo: 'Kaltura视频',
    selectDate: '请选择日期',
    selectTime: '请选择时间',
    orderTips: '（0.0 - 100.0，中文：数值越大，展示顺序越靠前）',
    clickToJump: '用户点击跳转到',
    eventVideoAndSpeaker: '活动（视频和演讲者）',
    allowPDFDownload: '允许PDF下载',
    moduleSort: '模块排序'
  },
  eventClient: {
    startTime: '开始时间',
    upcoming: '即将开始',
    speakerInformation: '演讲者信息',
    time: '时间',
    venue: '地址',
    organizer: '组织者',
    relatedBASFProduct: '巴斯夫产品',
    relatedFormulation: '巴斯夫配方',
    relatedConcept: '概念',
    relatedTrend: '趋势',
    viewDetail: '查看详情',
    viewPage: '查看页面',
    viewDocument: '查看文档',
    rateComment: '评分和评论',
    claim: '宣称',
    function: '功效',
    inci: '成分',
    formOfDelivery: '形态',
    yourComment: '添加评论',
    qustion1: '你觉得这个巴斯夫产品满足你的要求了么？',
    qustion2: '你觉得这个配方满足你的要求了么？',
    qustion3: '您多大程度上同意以下巴斯夫产品描述？',
    qustion4: '您多大程度上同意以下配方描述？',
    addNewAspect: '添加新属性作评分',
    newAspect: '新属性',
    writeYourComment: '写下你的评论'
  },
  account: {
    userId: '用户ID',
    account: '用户名（邮箱）',
    name: '昵称',
    title: '职称',
    tel: '联系方式',
    pass: '密码',
    conPass: '确认密码',
    role: '角色',
    expert: '专家',
    status: '状态',
    addAccount: '添加用户',
    editAccount: '编辑用户',
    country: '地区',
    addRole: '添加角色',
    editRole: '编辑角色',
    roleName: '角色名',
    download: '下载',
    roleId: '角色ID',
    roleAuth: '角色权限',
    downAuth: '下载权限（web）',
    BASFProductAuthority: '巴斯夫产品详情展示权限（web）',
    AppBASFProductAuthority: '巴斯夫产品详情展示权限（App）',
    withoutPermission: '无权限情况下，勾选则显示“升级以解锁此部分”，不勾选则显示“详细信息请与您的巴斯夫销售代表联系”',
    noTickText: '详细信息请与您的巴斯夫销售代表联系',
    userGroupName: '用户组名',
    addGroup: '添加用户组',
    editGroup: '编辑用户组',
    user: '用户',
    displayAuth: '显示权限（web）',
    userType: '用户类型',
    sendMail: '给用户发送角色改变邮件',
    tips: '提示',
    powerUser: '超级管理员',
    company: '公司名',
    department: '部门',
    fontEndManage: 'web端管理',
    userManage: '角色和综合管理',
    dataManage: '后端数据管理',
    appManage: 'App前端管理',
    register: '注册时间',
    superUserTip: '超级用户对所有数据拥有完全的访问权限，不受“指定用户”的影响',
    disabledGroup: '<span style="color: red;">标红</span>标红的为已停用的用户组',
    userGroup: '用户组',
    effectivePeriod: '权限有效期',
    chooseExpiryDate: '选择到期时间',
    effectivePeriodTip: '到达有效期后，用户权限将变为默认的免费权限<br>例如，设置的到期时间为1月1日，则用户的权限将在1月1日 23:59:59后变为free',
    expiryDate: '权限到期时间',
    lastExpiredRole: '最近到期权限',
    expiry: '权限到期时间',
    desc: '对用户的描述',
    descTips: '此处填写的内容，将在使用该角色的用户的APP个人中心页展示',
    viewAccount: '查看账号',
    deregistration: '注销',
    deregistrationStatus: '注销状态',
    deregistrationTitle: '注销账号',
    carefully: '请谨慎操作！',
    deregistrationTips: '账号注销后，以下信息将被清空且无法找回',
    carefully1: '• 账号权限信息',
    carefully2: '• 个人资料',
    carefully3: '• 个人收藏',
    carefully4: '• 我的订单',
    deregistrationSure: '确定要<span style="color: #FF0000">注销</span>该账号吗?',
    massSelect: '批量选择',
    massTips: '请输入账号E-mail，用“,”或者 <span style="font-style:italic;">ENTER</span>隔开，最大输入长度为2500字符',
    checkAccount: '检查账号',
    unMatched: '未匹配',
    matched: '匹配',
    import: '导入',
    undo: '撤销',
    pleaseEnterAccount: '请输入账号E-mail',
    exportPermissionList: '导出权限列表',
    exportRoleList: '导出角色列表',
    selected: '已选择',
    massAssignRoles: '批量分配角色',
    massEdit: '批量编辑账号',
    presetRole: '预设角色',
    massDeleteRoles: '批量删除角色',
    deleteFailedTips: '删除失败User ID',
    registerAccount: '注册激活账号',
    inactive: '待激活',
    activated: '已激活',
    expired: '已过期',
    customerCompany: '客户公司',
    customerGroup: '客户集团',
    userCompanyTips1: '你可以查看用户公司列表，以及管理用户公司与客户公司、客户集团、用户类型的规则',
    userCompanyTips2: '提示：修改此处规则，会立即修改所有符合规则的用户个人资料，请谨慎操作',
    suffixTips: '系统检测到，以下账号已符合您的白名单规则，是否需要覆盖以下用户信息？',
    lastDisableTime: '最后禁用时间',
    currentRole: '当前角色',
    requestedAccess: '请求的权限',
    randomPassword: '随机密码'
  },
  basfProduct: {
    addBasfProduct: '+ 添加巴斯夫产品',
    valueProposition: '产品介绍',
    files: '文件',
    specification: '说明文档',
    technicalInformation: '技术资料',
    statement: '声明',
    certificates: '证书',
    marketingInformation: '市场推广信息',
    marketingInformationPremium: '市场推广信息（俱乐部会员）',
    webAndApp: 'Web & App',
    webOnly: 'web only',
    changeStatusTitle: '你确定调整以下巴斯夫产品状态为 {current} ?',
    disable: '停用',
    enable: '启用',
    basfProductName: '巴斯夫产品名称',
    PRDNumber: 'PRD号',
    keyFocusProduct: '热门推荐',
    requestDocumentation: '申请产品文档',
    requestedTips: '您的申请正在审批中',
    BASFProduct: '巴斯夫产品',
    email: '邮箱',
    name: '姓名',
    company: '公司',
    telephone: '联系电话',
    additionalRequests: '对其他产品的额外需求',
    otherProducts: '请说明其他产品或需求',
    submitSuccessfully: '提交成功',
    sampleRequest: '获取样品',
    telephoneIsRequired: '联系电话必填',
    dataNoFound: '数据未找到',
    addCartSuccess: '本产品已加入购物车',
    submitSuccess: '提交成功',
    submitFailure: '提交失败',
    addressIsRequire: '地址必填',
    addCartText: '索样',
    languageLimitTrade: '抱歉，该产品不在当前区域销售',
    toxAbstract: '毒理摘要: (声明)'
  },
  exportResult: {
    start: '起始',
    end: '终止',
    export1: '一次性只能导出',
    export2: '条数据',
    compare: '起始值不得大于终止值',
    downloading: '开始下载',
    downloadFail: '下载失败',
    to: '至'
  },
  relationship: {
    addForm: '添加新形态',
    editForm: '编辑形态',
    addApplication: '添加新应用领域',
    editApplication: '编辑应用领域',
    addBenefit: '添加新用户宣称',
    editBenefit: '编辑用户宣称',
    addGroup: '添加新产品分组',
    editGroup: '编辑产品分组',
    tradeName: '配方产品名称',
    fucntion: '使用目的',
    type: '类型',
    relatedProduct: '巴斯夫相关联的产品',
    relatedPrd: '巴斯夫相关联的prd',
    addCompetitor: '添加巴斯夫竞品',
    editCompetitor: '编辑巴斯夫竞品',
    competitorProduct: '竞品产品',
    productName: '产品名称',
    companyName: '公司名称',
    competitorName: '竞品产品名称',
    inci: '成分',
    relatedCompetitor: '相关联的其他公司的产品',
    editClaim: '编辑宣称',
    addFunction: '添加新功效',
    editFunction: '编辑功效',
    claimTips: '管理产品宣称的模块，您可以设置产品宣称之间的相似关系',
    productTips: '管理巴斯夫配方提取出来的产品，您可以辨别哪些产品是巴斯夫提供的，哪些是其他公司提供的',
    applicationTips: '您可以在这里管理巴斯夫产品的应用领域',
    deliveryTips: '您可以在这里管理巴斯夫产品的运输形态',
    benefitTips: '您可以在这里管理巴斯夫产品的消费者利益',
    groupTips: '您可以在这里管理巴斯夫产品的分组',
    functionTips: '您可以在这里管理巴斯夫产品的功效',
    brandClaimTips: '管理产品宣称的模块，您可以设置品牌宣称之间的相似关系',
    BASFMarkTips: '您可以在这里人工管理每个INCI是否标记【BASF】',
    sourceName: '来源',
    sourceForulationId: '来源配方ID',
    dliteFunctionTips: "您可以在这里管理D'litE成分功效",
    dliteFunction: "D'litE成分功效",
    dliteFunctionEn: "D'litE成分功效（英文）",
    dliteFunctionCn: "D'litE成分功效（中文）",
    dliteFunctionJp: "D'litE成分功效（日文）",
    dliteFunctionExist: '中文名或英文名已存在',
    updateTime: '更新时间',
    basfFunction: '巴斯夫产品功效',
    basfFunctionEn: '巴斯夫产品功效（英文）',
    basfFunctionCn: '巴斯夫产品功效（中文）',
    basfFunctionExist: '中文名或英文名已存在',
    bevolFunctionTips: "您可以在这里管理美修成分功效",
    bevolFunctionEn: 'Bevol成分功效',
    bevolFunctionCn: 'Bevol成分功效（中文）',
    bevolFunctionJp: 'Bevol成分功效（日文）',
    bevolFunctionStatus: '作为使用目的',
    matchingFunction: "对应D'litE成分功效",
    editBevolFunction: '编辑Bevol成分功效',
    deleteBenefitTips: '您确定要删除此消费者权益吗？',
    benefitIsUseTips: '系统中有BASF Product包含此Consumer benefit，请先取消关联',
    basfFunctionJp: '巴斯夫产品功效（日文）',
    commentKeywords: {
      keyword: '关键词',
      translationEn: '翻译（英文）',
      translationJp: '翻译（日文）',
      startDate: '开始时间',
      endDate: '结束时间',
      status: '状态',
      createTime: '创建时间',
      headerTips: '您可在此管理消费者产品里的文字云',
      addKeyword: '添加关键词',
      editKeyword: '编辑关键词',
      massUpload: '批量上传',
      uploadTips: '提示：此处修改，前端第二天才会生效',
      uploadTips2: '请使用导出的文件模版来上传需要更新的数据',
      uploadTips3: '系统将自动为您下载上传的结果，或者您可以点击下方按钮直接开始下载。',
      disableTips: '您确定要禁用它吗？',
      enableTips: '您确定要启用它吗？',
      deleteTips: '您确定您要删除吗？',
      illegalID: 'ID格式不正确',
      matching: '匹配',
      translation: '翻译',
      addTranslation: '添加翻译',
      translationHeaderTips: '您可在此管理消费者产品里的文字云翻译',
      editMatching: '编辑匹配',
      BEVOLKeyword: 'BEVOL关键词',
      matchingDlitE3XKeyword: '匹配DlitE3X关键词',
      type: '类型',
      positive: '正面',
      negative: '负面',
      neutral: '中性',
      dlitE3XKeyword: 'DlitE3X关键词',
      dlitE3XKeywordCn: 'DlitE3X关键词(中文)',
      dlitE3XKeywordJp: 'DlitE3X关键词(日文)',
      matchingBEVOLKeyword: '匹配BEVOL关键词',
      editTranslation: '编辑翻译',
      keywordHasExist: '关键词已存在',
      DlitE3XKeywordIsNotEmpty: 'DlitE3X关键词不为空'
    },
    claim: {
      matching: '匹配',
      translation: '翻译',
      addTranslation: '添加翻译',
      translationTips: '您可在此管理消费者产品里的宣称翻译',
      dlitE3XClaim: 'DlitE3X宣称',
      dlitE3XClaimCn: 'DlitE3X宣称(中文)',
      dlitE3XClaimJp: 'DlitE3X宣称(日文)',
      dlitE3XClaimKana: 'DlitE3X宣称假名(日文)',
      matchingBEVOLClaim: '匹配美丽修行宣称',
      matchingBEVOLClaimIsNotEmpty: '匹配美丽修行宣称不为空',
      similarClaim: '相似宣称',
      nameExist: '该名称已存在',
      createTime: '更新时间',
      claim: '宣称',
      note: '提示：此处修改，前端第二天才会生效',
      matchingTips: '您可在此管理消费者产品里的宣称',
      editMatching: '编辑匹配',
      editTranslation: '编辑翻译',
      matchingDlitE3XClaim: '匹配DlitE3X宣称',
      BEVOLClaim: '美丽修行宣称',
      isNotEmpty: 'DlitE3X宣称不为空'
    }
  },
  aboutBASF: {
    addContactor: 'Add New Contactor',
    contactorName: 'Contactor Name',
    email: 'E-mail',
    expert: 'Expert',
    search: 'Search',
    yes: 'Yes',
    no: 'No',
    contactorPicture: 'Contactor Picture',
    title: 'Title',
    introductionDocument: 'Introduction Document',
    weight: 'Weight',
    operation: 'Operation',
    uploadDocument: 'Upload Introduction Document',
    addAboutBASF: 'Add Contactor',
    editAboutBASF: 'Edit Contactor'
  },
  appPictures: {
    moduleMainPicture: 'APP Module Main Picture',
    banner: 'APP Banner',
    openScreen: 'APP Open screen',
    position: 'Position',
    picture: 'Picture',
    link: 'Link',
    longImage: 'Long image',
    addBanner: 'Add New Banner',
    languageTips: '选择在哪种语言环境下展示'
  },
  messageModule: {
    number: 'NO.',
    sendMessage: 'Send New Message',
    viewMessage: 'View Message',
    title: 'Title',
    date: 'Sent Date',
    sender: 'Sender',
    content: 'Content',
    recipient: 'Recipient',
    recipientUser: 'Recipient User',
    recipientGroup: 'Recipient Group',
    messageType: 'Message Type',
    start: 'Start  Date',
    end: 'End Date',
    receiver: 'Receiver'
  },
  messageCenter: {
    messageCenter: '消息中心',
    viewDetail: '查看详情',
    sender: '发件人',
    message: '信息内容',
    messageDataOwner: '发送消息给{name}的所有者',
    messageType: '消息类型',
    title: '标题',
    start: '开始时间',
    end: '结束时间',
    total1: '总共',
    total2: '条记录',
    systemAutomatic: '系统消息',
    manual: '人工发送',
    recipient: '接收人'
  },
  coowner: {
    group: 'Please select Co-owner role',
    supportUserGroup: 'Please select technical support message role',
    securityUserGroupId: 'Please select security role',
    general: '通用',
    customerContact: '客户联系',
    account: '账号',
    addCustomerContact: '新增客户联系',
    editCustomerContact: '编辑客户联系',
    requiredLocations: '地区为必填项',
    selectRole: '请选择角色',
    maximumRole: '最多添加5个角色',
    selectAccount: '请选择账号',
    maximumAccount: '最多添加10个账号',
    red: '红色',
    disabledTips: '禁用用户账号/角色',
    remarks: '提示',
    emptyTips: 'role或account不能都为空',
    customerFeedback: '请设置用户接收客户反馈'
  },
  activityLog: {
    userId: '用户ID',
    userName: '用户名',
    userAccount: '用户账号',
    action: '动作',
    contentTitle: '内容标题',
    module: '模块',
    documentRequest: '文档请求',
    download: 'Download',
    dataUpdate: 'Data Update',
    accessRights: 'Access Rights',
    activityID: '活动ID',
    actionTime: '操作时间',
    sectionPage: '章节/页面',
    targetPage: '目标页面',
    tabName: '文章标题',
    downloadAmount: 'Download Amount'
  },
  whiteList: {
    company: '公司',
    account: '账号（e-mail）',
    role: ' 角色',
    group: 'User group',
    registerStatus: '注册状态',
    userType: '用户类型',
    accountTips: '请确认这是用户注册时使用的邮箱，添加多个账号时，用“,”分隔',
    domainTips: '请确认这是域名邮箱，当添加多个域名邮箱时，用“，”隔开（例如：@basf.com,@partners.basf.com）',
    maxAccount: '一次最多可以添加30个帐户',
    maxDomain: '最多可同时添加30个域名邮箱',
    alreadyAccount: '下列帐户已存在，不能重复添加',
    alreadyDomain: '以下域名邮箱已存在，不能重复添加',
    emailError: '账号（邮箱）格式不正确',
    domainError: '非法域名邮箱',
    repeatedlyAccount: '重复输入以下帐户',
    repeatedlyDomain: '以下域名邮箱被重复输入',
    roleEffectivePeriod: '角色有效期',
    yes: '有',
    no: '无',
    Days: '天',
    userTypeLabel: '所有账号的用户类型',
    remark: '备注',
    addWhiteList: '添加白名单',
    editWhiteList: '编辑白名单',
    selected: '已选择',
    massAssignRoles: '批量分配角色',
    massEdit: '批量编辑',
    presetRole: '预设角色',
    massDeleteRoles: '批量删除角色',
    massEditWhiteList: '批量编辑白名单',
    personalMail: '个人邮箱',
    domainMail: '域名邮箱',
    registeredAccountAmount: '已注册账号数量',
    registeredAccount: '已注册账号',
    registerTime: '注册时间',
    close: '关闭',
    domainMailTips: '请填写正确的邮箱后缀格式（例如：@basf.com）】',
    customerCompanyTips: '客户公司（{current}）已存在',
    scource: '来源',
    userRegistration: '用户',
    whiteList: '管理员',
    customerCompany: '客户公司',
    viewListTips: '你可以查看用户公司列表，以及管理用户公司与客户公司、客户集团、用户类型的规则',
    editTips: '提示：修改此处规则，会立即修改所有符合规则的用户个人资料，请谨慎操作',
    editCustomerCompanyTitle: '编辑客户公司',
    customerCompanyAndGroup: '客户公司和集团',
    companyHasExist: '客户公司已存在',
    addToSelected: '添加至已选项',
    customerCompanyAndGroupRequired: '添加至已选项',
    selectedBtn: '已选项'
  },
  blackList: {
    addBlackList: '添加黑名单',
    editBlackList: '编辑黑名单',
    setUserType: '设置用户类型',
    userTypeTips: '当用户注册账号成功后，如果邮箱命中规则，此用户类型会自动变为以上类型，并且账号自动变为禁用状态'
  },
  inciManagement: {
    massUpdate: '批量上传更新',
    uploadTips1: '请使用导出的文件模版来上传数据，请使用“,”来分隔多条数据内容',
    uploadTips2: '一次最多只能上传3000条数据',
    verifyTips: '校验上传结果',
    verifyTips1: '系统只会处理您上传文件中的功效（手动设置）和使用目的（手动设置）',
    verifyTips2: '如果上传的文件中有系统未能识别的数据，成分名将会标红展示，您可以在表格中再检查调整。',
    pleaseUpload: '请先上传文件',
    functionManual: '功效（手动设置）',
    claimManual: '使用目的（手动设置）',
    submitUpdate: '提交更新',
    uploadItem: '上传条目数',
    failedItem: '未识别条目数',
    inciName: '成分名称',
    inciNameDisplayed: '成分展示名',
    casNum: '成分备案号',
    releaseRegion: '成分可用国家',
    releaseRegionManual: '成分可用国家（手动设置）',
    functional: '功效',
    functionClaim: '使用目的',
    bMark: 'B 标签',
    uploadFailed: '上传失败，请上传符合要求的excel文件',
    inciNameEn: '成分名称（英文）',
    inciNameCn: '成分名称（中文）',
    inciNameJp: '成分名称（日本語）',
    qdNameJp: 'QD Name（JP）',
    inciNameDisplayedEn: '成分展示名（英文）',
    inciNameDisplayedCn: '成分展示名（中文）',
    inciNameDisplayedJp: '成分展示名（日本語）',
    inciNameDisplayedEnTips: '成分展示名（英文）已存在',
    inciNameDisplayedCnTips: '成分展示名（中文）已存在',
    inciNameDisplayedJpTips: '成分展示名（日本語）已存在',
    functionClaimOriginal: '使用目的（原始数据）',
    qdNameIsNotEmpty: 'QD Name不为空'
  },
  userBehavior: {
    countryDisTitle: '用户地区分布',
    typeDisTitle: '用户类型分布',
    departmentDisTitle: '用户部门分布',
    country: '国家',
    userNum: '用户数',
    rate: '占比',
    userType: '用户类型',
    department: '部门',
    newUser: '新用户',
    newUserYesterday: '昨日新增用户数',
    newUserLastWeek: '上周新增用户数',
    newUserLastMonth: '上月新增用户数',
    activeUser: '活跃用户',
    activationAnalysis: '用户新增与活跃分析',
    last7Days: '过去7天',
    last30Days: '过去30天',
    last3Months: '过去3个月',
    dailyActiveUser: '日活跃用户数（近30日平均）',
    weeklyActiveUser: '周活跃用户数（上周）',
    monthlyActiveUser: '月活跃用户数（上月）',
    activeDay: '活跃天数',
    weekAverageActiveDay: '周平均活跃天数',
    monthAverageActiveDay: '月平均活跃天数',
    onlineTime: '活跃时长',
    dailyAverageOnlineTimeYesterday: '日均使用时长（昨天）',
    dailyAverageOnlineTimeWeek: '日均使用时长（上周）',
    dailyAverageOnlineTimeMonth: '日均使用时长（上月）',
    visitedPage: '访问页面数',
    averageVisitedPageYestoday: '平均访问页面数（昨天）',
    averageVisitedPageWeek: '平均访问页面数（上周）',
    averageVisitedPageMonth: '平均访问页面数（上月）',
    mostlyVisited: '访问最多的Top 10',
    yesterday: '昨天',
    newUserRetention: '新用户留存分析',
    moduleClickAnalysis: 'App模块点击分析',
    clickOfPage: '首页点击分析',
    clickOfPageTips: '占比 = 模块点击数/各模块点击数之和',
    searchOfPage: '搜索页点击分析',
    searchOfPageTips: '占比 = 模块点击数/各模块点击数之和',
    days: '天',
    day: '天',
    newUserLabel: '新用户',
    activeUserLabel: '活跃用户',
    userCount: '用户数',
    databaseBasicData: '数据库基础数据',
    visitData: '访问数据',
    hitData: '点击数据',
    maxTimeRangTips: '可选择时间区间最大为31天，您选择的时间区间超过最大限定，请重新选择。',
    totalRecord: '总记录:',
    EachTime5000: '一次性只能导出不超过 50,000 条数据',
    EachTime31: '可选择时间区间最大为31天，您选择的时间区间超过最大限定，请重新选择。',
    timePeriodNewUser: '时间段新增用户数<br>（{current}）',
    timePeriodActiveUser: '时间段活跃用户数<br>（{current}）',
    newUserYesterdayTips: '新增用户数（昨日）：昨日0点-24点完成注册的用户',
    newUserLastWeekTips: '新增用户数（上周）：上周一0点-上周日24点完成注册的用户',
    newUserLastMonthTips: '新增用户数（上月）：上个月1号0点-上个月31号24点完成注册的用户',
    timePeriodNewUserTips: '时间段新增用户数（YYYY-MM-DD-YYYY-MM-DD）：选定时间段内0点-24点完成注册的用户',
    dailyActiveUserTips: '日活跃用户数（近30日平均）：最近30天活跃用户总数（用户id去重）/30',
    weeklyActiveUserTips: '周活跃用户数（上周）：上周一0点-上周日24点活跃的用户总数（用户id去重）',
    monthlyActiveUserTips: '月活跃用户数（上月）：上个月1号0点-上个月31号24点活跃的用户总数（用户id去重）',
    timePeriodActiveUserTips: '时间段活跃用户数（YYYY-MM-DD-YYYY-MM-DD）：在某个时间段内0点-24点的活跃用户总数（用户id去重）',
    timePeriodActiveDay: '时间段平均活跃天数<br>（{current}）',
    weekAverageActiveDayTips: '周平均活跃天数（上周）：上周一0点-上周日24点活跃总天数/活跃用户总数（用户id去重）<br>例如：上周有两个活跃用户A和B，A活跃了3天，B活跃了5天，那么周平均活跃天数为4天；',
    monthAverageActiveDayTips: '月平均活跃天数（上月）：上个月1号0点-上个月31号24点的活跃总天数/活跃用户总数（用户id去重）',
    timePeriodActiveDayTips: '时间段平均活跃天数（YYYY-MM-DD-YYYY-MM-DD）：选定时间段0点-24点的活跃总天数/活跃用户总数（用户id去重）',
    timePeriodOnlineTime: '时间段日均使用时长<br>（{current}）',
    dailyAverageOnlineTimeYesterdayTips: '日均使用时长（昨天）：昨天0点-昨天24点符合筛选条件的所有用户使用时长/符合筛选条件的用户总数（用户id去重）',
    dailyAverageOnlineTimeWeekTips: '日均使用时长（上周）：上周一0点-上周日24点符合筛选条件的所有用户使用时长/符合筛选条件的用户总数（用户id去重）',
    dailyAverageOnlineTimeMonthTips: '日均使用时长（上月）：上个月1号0点-上个月31号24点符合筛选条件的所有用户使用时长/符合筛选条件的用户总数（用户id去重）',
    timePeriodOnlineTimeTips: '时间段日均使用时长（YYYY-MM-DD-YYYY-MM-DD）：选定时间段0点-24点符合筛选条件的所有用户使用时长/符合筛选条件的用户总数（用户id去重）',
    timePeriodVisitedPage: '时间段平均访问页面数<br>（{current}）',
    averageVisitedPageYestodayTips: '平均访问页面数（昨天）：昨天0点-昨天24点符合筛选条件的所有用户访问页面数/符合筛选条件的用户总数（用户id去重）',
    averageVisitedPageWeekTips: '平均访问页面数（上周）：上周一0点-上周日24点符合筛选条件的所有用户访问页面数/符合筛选条件的用户总数（用户id去重）',
    averageVisitedPageMonthTips: '平均访问页面数（上月）：上个月1号0点-上个月31号24点符合筛选条件的所有用户访问页面数/符合筛选条件的用户总数（用户id去重）',
    timePeriodVisitedPageTips: '时间段平均访问页面数（YYYY-MM-DD-YYYY-MM-DD）： 选定时间段0点-24点符合筛选条件的所有用户访问页面数/符合筛选条件的用户总数（用户id去重）',
    mostlyVisitedTips: '展示访问pv最多的前10个模块<br>展示访问某个模块最多的前10条数据',
    newUserRetentionTips: '新用户留存率（天）：（注册后的第X天仍在活跃用户数/新注册用户数）*100%<br>例如：2021-10-18注册的用户留存率（第2天）=（2021-10-19仍在活跃的用户数/2021-10-18注册的用户数）*100%<br><br>新用户留存率（周）：（注册后的第X周仍在活跃用户数/新注册用户数）*100%<br>例如：2022-1-3~2022-1-9注册的用户留存率（第2周） =（在2022-1-10~2022-1-16时间段内仍在活跃的用户数/2022-1-3~2022-1-9注册的用户数）*100%<br><br>新用户留存率（月）：（注册后的第X月仍在活跃用户数/新注册用户数）*100%<br>例如：2021-10注册的用户留存率（第2个月）= 11月仍在活跃的用户数/2021-10注册的用户数）*100%'
  },
  register: {
    register: '注册',
    email: '邮箱',
    emailTips: '请使用公司邮箱',
    verificationCode: '验证码',
    getCode: '获取验证码',
    password: '密码',
    confirmPassword: '确认密码',
    company: '公司',
    department: '部门',
    phone: '电话',
    name: '名称',
    locations: '地区',
    success: '注册成功',
    placeholder: {
      email: '你的邮箱',
      verificationCode: '你的验证码',
      password: '你的密码',
      company: '你的公司',
      department: '你的部门',
      phone: '你的电话',
      name: '你的名称',
      locations: '你的地区'
    },
    SendActivationEmail: '发送激活邮件',
    emainExists: '该账号 {current} 已经存在，请继续登录',
    existsTips: '如果您忘记了密码，请点击“忘记密码”去重置',
    registerSuccessTips1: '注册成功',
    registerSuccessTips2: '我们已经给您的邮箱{current}发送了一封激活邮件，请登录邮箱点击链接去激活您的账号。',
    registerSuccessTips3: '如果您没有收到激活邮件，请联系我们 {current}',
    registerPendingTips1: '已发送验证邮件到{current}',
    registerPendingTips2: '没有收到邮件？',
    registerPendingTips3: '发送激活邮件',
    mobilePhone: '联系方式',
    registerStatus: '注册状态',
    activate: '激活',
    activateTips: '您确定要激活这个账号？',
    activationSuccessful: '激活成功',
    emailExist: '当前邮箱存在，请换一个',
    emailRegistered: '该邮箱已注册，待激活',
    emailSendSuccess: '邮件发送成功',
    submitSuccess: '提交成功',
    submitFailure: '提交失败',
    emailNotExist: '该账号不存在，请重新注册',
    emailHasExist: '该账号已经存在，请直接登录',
    emailExpired: '该账号激活时间已过期，请重新注册'
  },
  homePage: {
    lastUpdate: '最新更新',
    latestUpdate: '最近更新',
    mostView: '最受欢迎',
    highLight: '热门推荐',
    noAccessTips: '抱歉，你无权限查看详情。',
    unlockTips: '升级以解锁此部分',
    tips: '提示',
    goPremium: '账号升级！',
    upgrade: '升级为',
    clubMember: 'D’litE<sup style="vertical-align: super;">3</sup>X 俱乐部成员',
    toUnlock: '去解锁更多超值内容。',
    bigDataAnalytics: '大数据分析',
    consumerInsights: '面向市场的消费者洞察',
    premiumDocuments: '更多优质文献',
    account: '账号（邮箱）',
    company: '公司',
    country: '国家',
    clickTips: '点击下方按钮提交申请。您可以在用户中心修改您的个人资料。',
    recommendTips: '我们强烈建议您使用公司邮箱来申请账号升级，不要使用私人邮箱。',
    applyForUpgrade: '立即申请',
    contactTips: '或者您可以联系您的巴斯夫商务代表获取更多信息。',
    thanks: '感谢您对D’litE3X俱乐部的关注。您的申请已进入审批程序。',
    unsuccessfulTips: '如果您在一个月内未得到答复，请联系销售人员或电子邮件<a style="color: #007F42" target="_blank" href="mailto:CS.DlitE3-X@basf.com">CS.DlitE3-X@basf.com</a>。谢谢！',
    year: '年份',
    locantion: '地区',
    basfProduct: '巴斯夫产品',
    trend: '趋势',
    concept: '概念',
    newUnlockTips: '该信息只对内部用户开放',
    subscriptionTips: '详细信息请与您的巴斯夫销售代表联系',
    goClub: {
      goClub: '账号升级！',
      upgradeTo: '<span>D’litE<sup style="vertical-align: super;">3</sup>X 俱乐部成员</span>去解锁更多超值内容',
      tips1: '面向市场的消费者洞察与分析',
      tips2: '俱乐部会员独家文档',
      processTips: '预计一周内处理您的申请，结果将通过Email通知您',
      thanks: '感谢您对D’litE3X俱乐部的关注。您的申请已进入审批程序。'
    },
    goPremiumObj: {
      goPremium: '付费升级！',
      subscribeTo: '订阅为<span>D’litE<sup style="vertical-align: super;">3</sup>X 付费会员</span>去解锁更多超值内容',
      tips1: '大数据分析',
      tips2: '全球市场和消费者洞察',
      tips3: '巴斯夫独家化学数据和数字工具',
      processTips: '您的申请将提交给当地销售代表。如果您在10个工作日内没有收到回复，请联系客服(CS.DlitE3-X@basf.com)寻求帮助。',
      applyForSubscribe: '立即订阅',
      thanks: '感谢您对D’litE3X付费的关注。您的申请已进入审批程序。'
    }
  },
  search: {
    moreBrands: 'More brands',
    moreProducts: 'More products',
    moreIngredients: 'More ingredients',
    moreBASFProducts: 'More BASF Products',
    moreTrends: 'More Trends',
    moreFormulations: 'More formulations',
    moreDocument: 'More document',
    moreConcept: 'More concept',
    moreVideo: 'More video',
    searchDlitE3X: '搜索D\'litE3X',
    searchBrand: '搜索品牌',
    searchProducts: '搜索产品',
    searchFormulation: '搜索配方',
    searchIngredient: '搜索成分',
    searchBASFProduct: '搜索巴斯夫产品',
    searchConcept: '搜索概念',
    searchTrend: '搜索趋势',
    searchVideo: '搜索视频',
    searchDocuments: '搜索文档',
    searchEvent: 'Search Event'
  },
  EcoStatusMap: {
    BASFNatural: 'From 100% natural, renewable feedstocks; Physically purified by water/achohol or energy.',
    BASFNaturalModified: 'From 100% natural, renewable feedstocks; Chemically processed, catalyst or reaction aids used.',
    BASFEcohybrids: 'From 100% natural, renewable & synthetic feedstocks; Renewable & synthetic building blocks are combined in a chemical process. Share nature C-atoms > 70%.',
    BASFHybrids: 'From 100% natural, renewable & synthetic feedstocks; Renewable & synthetic building blocks are combined in a chemical process. Share nature C-atoms < 70%.',
    BASFSynthetics: 'From synthetic feedstocks; Chemically processed.',
    BASFInorganics: 'From inorganic feedstocks',
    BASFAnimals: 'From animal feedstocks',
    title: {
      BASFNatural: 'BASF Natural',
      BASFNaturalModified: 'BASF Natural modified',
      BASFEcohybrids: 'BASF Ecohybrids',
      BASFHybrids: 'BASF Hybrids',
      BASFSynthetics: 'BASF Synthetics',
      BASFInorganics: 'BASF Inorganics',
      BASFAnimals: 'BASF Animals'
    }
  },
  media: {
    description: 'Description',
    select: 'Select',
    relatedVideo: 'Related Video',
    inputVideoTitle: 'Input Video title',
    addVideo: 'Add Video',
    relatedEvent: '相关活动',
    relatedWebinar: '相关线上研讨会',
    transcodedTips: '视频转码中，请耐心等待'
  },
  orderList: {
    additionalRequests: '其他请求',
    time: '时间',
    CoownerRole: 'Co-owner角色',
    CoownerAccount: 'Co-owner账号',
    View: '查看',
    requestList: '申请列表'
  },
  consumerProducts: {
    productList: '产品列表',
    briefAnalysis: '简要分析',
    brand: '品牌',
    brandName: '品牌名称',
    category: '分类',
    claims: '宣称',
    productForm: '产品形态',
    productAspect: '产品包装',
    sunscreenLevelSPF: '防晒等级-SPF',
    sunscreenLevelPA: '防晒等级-PA',
    includedINCI: '包含INCI',
    excludedINCI: '不包含INCI',
    priceRange: '价格范围',
    price: '价格',
    launchYear: '商品备案年份',
    year: '年份',
    sortBy: '排序',
    export: '导出',
    default: '默认',
    click: '点击量',
    favorite: '收藏量',
    comment: '评论数',
    updateTime: '更新时间',
    capacity: '容量',
    claim: '宣称',
    mainIngredients: '主要成分',
    benchmarkFormulation: '对标的巴斯夫配方',
    top10ClaimsProductForm: '最热门十大宣称产品形态分布',
    top10ClaimsSubCategory: '最热门十大宣称产品市场分类分布',
    top10ProductsProductForm: '最热门前10产品宣称产品形态分布',
    top10ProductsSubCategory: '最热门前10产品宣称产品市场分布',
    brandPositioning: '品牌定位',
    pricePositioning: '价格定位',
    market: '市场',
    brandGroup: '品牌集团',
    manufacture: '工厂',
    subCategory: '二级分类',
    dataFromCFDA: 'NMPA备案编号',
    CFDARegistrationYear: 'NMPA注册年份',
    applicationArea: '应用区域',
    packaging: '包装规格',
    clicks: '点击量',
    topTips1: 'Top{current} {quarter}在所有的产品中',
    topTips2: 'Top{current} {quarter}在相同分类的产品中',
    similarFormulationProduct: '相似的配方&产品',
    formulationWithSimilarClaim: '相同宣称的配方',
    FormulationThatYoMayAlsoLike: '你可能喜欢的配方',
    relatedBASFProduct: '相关巴斯夫产品',
    productsOfSameBrand: '相同品牌的产品',
    feedbackAnalysis: '评论消费者画像',
    scoring: '评分',
    reviews: '评论人数',
    location: '地区分布',
    province: '省',
    clicksRate: '点击率',
    commentsRate: '评论率',
    top20Comments: '前二十词频分布',
    consumerInsight: '市场洞察',
    skinType: '肤质分布',
    age: '年龄分布',
    clickDistribution: '点击分布',
    allDataRelated: '所有与点击相关的数据从2018年4月开始。',
    notAnswered: '未知',
    youMayBeInterestedIn: '你可能感兴趣的',
    brandSearch: '品牌搜索',
    claimsForm: '宣称/产品形态',
    claimsSubCategory: '宣称/产品市场分类',
    searchResult: '搜索结果',
    showMoreThan: '如果总记录超过10,000条，只显示前10,000条记录',
    chartTips: '消费者点击次数（占总用户的百分比）',
    positive: '正面',
    negative: '负面',
    neutral: '中性',
    top20Commentkeywords: '最热门的20个评论关键词',
    clickToExploreSentiments: '点击查看情绪',
    sentimentBreakdownOfKeyword: '关键词情绪分析',
    feedbackAnalysisTips: '消费者评论数和评分占比',
    locationTips: '各省消费者的评论数和评论率',
    clickDistributionTips: '近10个月消费者点击次数',
    locationClickTips: '各省消费者的点击量和点击率'
  },
  myProfile: {
    lastName: '姓',
    firstName: '名',
    pleaseUpdateYourNamingInformation: '请完善您的姓名信息',
    proceedToUpdate: '前往更新',
    tips: '提示',
    avatar: '头像',
    phone: '电话号码',
    emailAddress: '邮件地址',
    company: '公司',
    department: '部门',
    locations: '地区',
    setPassword: '设置密码',
    changePassword: '修改密码',
    securitySetting: '安全设置',
    accountDeregistration: '账号注销',
    edit: '编辑',
    editProfile: '编辑资料',
    changeAvatar: '修改头像',
    imgTips: '请上传2M以内、JPG/JPEG格式的图片',
    yourLastName: '你的姓',
    yourFirstName: '你的名',
    yourMobilePhone: '你的电话',
    yourCompany: '你的公司',
    yourDepartment: '你的部门',
    yourLocations: '你的地区',
    save: '保存',
    pleaseProceedCautiously: '请谨慎操作！',
    cancelledTips: '账号注销后，以下信息将被清空且无法找回',
    accountAccessInformation: '账号权限信息',
    myProfile: '个人资料',
    myFavorites: '我的收藏',
    myOrder: '我的订单',
    cancelledHandlerTips: '点击下方按钮申请注销，或者邮件联系我们：',
    applyForDeregistration: '申请注销',
    pendingApprovalTips: '你的申请正在审核中',
    applyTime: '申请时间：',
    applySuccess: '申请成功',
    mailTips: '如有任何疑问，请邮件联系我们：',
    getCode: '获取验证码',
    verificationCode: '验证码'
  },
  formulationClient: {
    category: '分类',
    claims: '宣称',
    productForm: '产品形态',
    productAspect: '产品包装',
    sunscreenLevelSPF: '防晒等级-SPF',
    sunscreenLevelPA: '防晒等级-PA',
    includedINCI: '包含INCI',
    excludedINCI: '不包含INCI',
    includeBasfProduct: '包含巴斯夫产品',
    excludeBasfProduct: '不包含巴斯夫产品',
    tags: '标 签',
    benchmarkProducts: '对标产品',
    subCategory: '二级分类',
    laboratoryCountry: '生产国家',
    applicationArea: '应用区域',
    subApplicationArea: '子应用区域',
    specificPopulationGroups: '特定人群',
    priceRange: '价格范围',
    formulationID: '配方ID',
    updateYear: '更新年份',
    owner: '所有者',
    functionalClaim: '功效宣称',
    description: '描述',
    downloadFormulationPDF: '下载配方PDF',
    downloadAsPDF: '下载为PDF',
    others: '其他',
    ingredients: '成分',
    phase: '阶段',
    BASFProduct: '巴斯夫产品',
    ecoStatus: '环保等级',
    INCIName: '成分名称',
    byWeight: '%重量',
    function: '功效',
    specifications: '规格',
    performance: '性能',
    manufacturingProcess: '制造工艺',
    downloadTips: '本配方提供中文PDF下载：',
    downloadBtnText: '下载中文配方PDF',
    chinese: '中文',
    japanese: '日文',
    english: '英文',
    similarFormulation: '相同宣称的配方',
    interestFormulation: '你可能喜欢的配方',
    KeyBASFProduct: '核心巴斯夫产品',
    relatedConcept: '相关概念',
    top10Products: '对标产品Top 10'
  },
  agreementDialog: {
    title: '用户协议与隐私政策',
    row1: '请你务必审慎阅读、充分理解”用户协议“各条款，包括但不限于',
    row2: '（1）《隐私政策》中关于个人设备的用户信息和使用说明。',
    row3: '（2）《隐私政策》中与第三方SDK类服务商的数据共享、相关信息收集和使用说明。',
    row4: '你可阅读《{agreement}》和《{policy}》了解详细信息。如你同意，请点击“同意”开始接受我们的服务。',
    agree: '同意并继续',
    exit: '暂不使用'
  },
  brandClient: {
    brandList: '品牌列表',
    marketOpportunity: '市场机遇',
    brandGroup: '品牌集团',
    category: '分类',
    claims: '宣称',
    origin: '起源地',
    brandPositioning: '品牌定位',
    pricePositioning: '价格定位',
    segment: '市场分类',
    year: '年份',
    country: '国家',
    brandPositioningMap: '品牌定位</br>（零售价值和增长率）',
    brandsClaims: '品牌宣称和分类分布',
    brandsCount: '品牌数',
    T10CCP: '最热门十大产品宣称类别分布',
    retailValue: '销售额',
    marketShare: '市场份额',
    growthRate: '增长率',
    productAmount: '产品数量',
    officialLink: '官网链接',
    majorProductCategory: '产品主要分类',
    majorProductSubCategory: '产品主要二级分类',
    description: '描述',
    claimsProducts: '宣称和产品',
    ingredients: '成分',
    consumerInsight: '消费者洞察',
    consumerInsightChina: '中国消费者洞察',
    marketData: '市场数据',
    productsCount: '商品数',
    top5ClaimsTips: '默认最近6年新发布产品中使用最多的5个宣称',
    allProducts: '全部产品',
    suggestedformulation: '根据热门宣称推荐的配方',
    moreformulation: '根据主要产品分类推荐的配方',
    subCategory: '二级分类',
    function: '功效',
    functionalClaim: '功效宣称',
    skinType: '肤质分布',
    age: '年龄分布',
    relatedBasfProduct: '相关巴斯夫产品',
    clicks: '点击分布',
    clicksTips: '所有与点击相关的数据从2018年4月开始。',
    location: '地区分布',
    province: '省',
    click: '点击量',
    clicksRate: '点击率',
    commentsRate: '评论率',
    comment: '评论数',
    comments: '评论数',
    commentsCount: '评论数',
    groupBrand: '集团品牌',
    claimsCategory: '宣称/分类',
    ingredientUsingTrend: '成分使用趋势',
    productName: '产品名称',
    categories: '分类',
    favorite: '收藏量',
    commentScore: '评分',
    commentNum: '评论数',
    rateTips: 'Rate=筛选条件下，含有该成分的产品数/总产品数',
    rate: '占比',
    BASFHas: '巴斯夫拥有这种成分',
    number: '数量',
    yearlyLaunchedProducts: '年度发布产品',
    clickCount: '点击量',
    topTips: 'Top{current} {quarter}在所有的品牌中',
    brandsUnderSameGroup: '集团下的其他品牌',
    marketCountry: '市场国家'
  },
  ingredientClient: {
    function: '功效',
    functionalClaim: '使用目的',
    releaseLocations: '成分可用国家',
    productCategory: '产品分类',
    productSubCategory: '产品二级分类',
    orderTips: '根据上一季度数据排序：',
    defaultOrder: '默认',
    clickOrder: '消费者点击量',
    userClickOrder: 'DlitE3X点击量',
    productAmongOrder: '含有成分的商品数',
    ingredientName: '成分名称',
    CASNumber: '成分备案号',
    addToCompare: '添加比较',
    alreadyAdded: '已添加',
    bevolClicks: '上季度点击数（Bevol）',
    dlite3Clicks: '上季度点击数（D’litE3X）',
    productCount: '上季度含有该成分的产品数',
    comparison: '对比',
    view: '查看',
    QDName: 'QD Name',
    clicks: '点击量',
    relatedProduct: '相关联的巴斯夫竞品',
    clicksTips: 'Top {current} {quarter}在所有成分中',
    ingredientsApplicationAnalysis: '成分应用分析',
    ingredientsApplicationAnalysisTips: '占比=筛选条件下，含有该成分的产品数/总产品数',
    brandGroup: '品牌集团',
    brand: '品牌',
    productsCount: '商品数',
    rate: '占比',
    year: '年份',
    consumerProductsAnalysis: '消费者产品分析',
    top10ProductTitle: '{current}年点击量排名前10的含有该成分的产品',
    NOConsumerProducts: '{current}年各分类含有该成分的产品数',
    viewMore: '查看更多有关此成分的市场洞察',
    collapse: '收起',
    relatedBASFProduct: '含有该成分的巴斯夫产品',
    relatedFormulation: '含有该成分的巴斯夫配方',
    moreInformation: '更多信息',
    ingredientCombination: '成分组合模拟器',
    functionCombination: '组合后的功效',
    relatedIngredient: '相关成分',
    percentageCorrelationRatio: '百分比是指相关比.',
    combinationRate: '组合比率',
    relatedFormulations: '同时含有<span>{inci}</span>和<span>{selectInci}</span>的巴斯夫配方',
    relatedFormulationTitle: '相关巴斯夫配方'
  },
  myComparison: {
    myComparison: '我的对比',
    brand: {
      brand: '品牌',
      tips: '最多可比较 <span>5</span> 个品牌！',
      addBrand: '添加品牌',
      basicInformation: '基本信息',
      brandOrigin: '品牌起源',
      brandPositioning: '品牌定位',
      pricePositioning: '价格定位',
      mainCategory: '主要分类',
      mainClaim: '主要宣称',
      productsQuantity: '产品数量',
      clicks: '点击量',
      marketInformation: '市场信息',
      marketShare: '市场份额',
      ranking: '排名',
      segment: '市场分类',
      subSegment: '市场二级分类',
      clicksTips: '2018年4月至今该品牌所有商品总点击次数'
    },
    product: {
      product: '产品',
      tips: '最多可比较 <span>5</span> 个产品！',
      addProduct: '添加产品',
      basicInformation: '基本信息',
      category: '分类',
      price: '价格',
      capacity: '容量',
      claims: '宣称',
      functionIngredients: '功效成分',
      clicks: '点击量',
      commentScore: '评分',
      comments: '评论数',
      functionalIngredientList: '功效成分列表',
      consumerSkinType: '消费者皮肤类型'
    },
    formulation: {
      formulation: '配方',
      tips: '最多可比较 <span>5</span> 个配方！',
      addFormulation: '添加配方',
      category: '分类',
      functionalClaim: '功效宣称',
      claims: '宣称',
      BASFProduct: '巴斯夫产品',
      ingredientName: '成分名称',
      INCI: '成分',
      function: '功效',
      hide: '隐藏',
      viewMore: '查看更多',
      specifications: '规格',
      performance: '性能',
      manufacturingProcess: '制造工艺'
    },
    inci: {
      INCI: '成分',
      tips: '最多可比较 <span>5</span> 个成分！',
      ingredientUsingTrend: '成分使用趋势',
      addIngredient: '添加成分',
      CASNumber: '成分备案号',
      releaseLocations: '成分可用国家',
      productsQuantity: '产品数量',
      clicks: '点击量',
      comments: '评论数',
      function: '功效',
      functionClaim: '使用目的'
    }
  },
  myComments: {
    myComments: '我的评论',
    allComments: '全部评论',
    replies: '我的回复',
    date: '时间',
    select: '请选择'
  },
  myFavorites: {
    myFavorites: '我的收藏',
    consumerProducts: '消费者产品',
    brand: '品牌',
    BASFProduct: '巴斯夫产品',
    formulation: '配方',
    concept: '概念',
    trend: '趋势',
    ingredient: '成分',
    cancelFavorite: '取消收藏',
    collectionOfSuccess: '收藏成功',
    canceledCollection: '已取消收藏'
  },
  myRequest: {
    myRequest: '我的申请',
    documentRequest: '文档请求',
    sampleRequest: '获取样品',
    module: '模块',
    title: '标题',
    PRDNumber: 'PRD号/ID',
    content: '内容',
    status: '状态',
    requestTime: '申请时间',
    approved: '通过',
    processing: '审核中',
    denied: '拒绝',
    additionalRequests: '其他请求',
    operator: '操作者',
    tabName: 'Tab名称',
    operationTime: '操作时间',
    done: '已处理',
    doneOff: '完成',
    sendFile: '发送文件',
    deny: '拒绝',
    reason: '原因',
    denyTips: '您确定您要拒绝吗？',
    doneTips: '您确定您要完成吗？',
    reason1: 'Your identity verification failed, possibly due to using a public email or the company being unrecognized',
    reason2: 'This product is not sold in your region',
    reason3: 'This product is only sold to certain specific customers',
    upgradeRequest: '升级请求',
    upgradeRequestReason1: 'Please register using your company email. We usually do not apply for upgrades through a public email domain.',
    upgradeRequestReason2: 'The information you provided is too limited to be accurately identified. Please provide complete personal information.'
  },
  recentlyViewed: {
    recentlyViewed: '最近浏览',
    showTips: '显示一年内查看内容'
  },
  deeplink: {
    tips: '您可以创建二维码，扫描二维码后，可以跳转到App指定的模块',
    module: '模块',
    creator: '创建人',
    startDate: '开始时间',
    endDate: '结束时间',
    addQRCode: '增加二维码',
    title: '标题',
    createTime: '创建时间',
    ccannedTimes: '扫描次数',
    downloadQRCode: '下载二维码',
    linkto: '链接至',
    dataTitle: '数据标题',
    versionTips: '因技术限制，只有v1.25.0及以上版本的APP可以实现自动跳转功能。',
    appStoreDownload: '应用商店下载',
    remarks: '备注',
    promotionActivity: '推广活动',
    utmSourceTips1: '请仅填写英文和数字，例如“202308CIDSEvent”',
    utmSourceTips2: '不要添加任何本地语言或符号，例如空格、“！”、“@”等'
  },
  promotionActivity: {
    addPromotionActivity: '增加推广活动',
    link: '链接',
    linkTips: '请输入要分享的DlitE3X链接'
  },
  role: {
    accessRole: '权限角色',
    groupRole: '群组角色',
    checkOne: '请至少勾选1个权限',
    dontCheck: '请不要勾选权限'
  }
}
export default cn



// WEBPACK FOOTER //
// ./src/lang/zh.js